
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("4t0X5", function(module, exports) {
$parcel$export(module.exports, "default", () => $2eb67ebc7290274a$export$2e2bcd8739ae039);

var $dqdTY = parcelRequire("dqdTY");

var $5dRZ5 = parcelRequire("5dRZ5");
function $2eb67ebc7290274a$var$handleError(event) {
    (0, $5dRZ5.globalErrorHandlerState).globalCount++;
    if (event.error?.UFOhasCaught === undefined) try {
        if (event.error instanceof Error) (0, $5dRZ5.globalErrorHandlerState).push('GlobalErrorHandler', null, event.error.name, event.error.message, event.error.stack);
        else if (event.error) {
            const hint = JSON.stringify(event.error).slice(0, 50);
            (0, $5dRZ5.globalErrorHandlerState).push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`);
        } else if (event.message !== undefined) {
            const hint = event.message.slice(0, 50);
            (0, $5dRZ5.globalErrorHandlerState).push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`);
        }
        if (event.error && typeof event.error === 'object') event.error.UFOhasCaught = true;
    // eslint-disable-next-line no-empty
    } catch  {}
}
function $2eb67ebc7290274a$var$handlePromiseRejection(event) {
    (0, $5dRZ5.globalErrorHandlerState).globalCount++;
    if (event.reason instanceof Error) (0, $5dRZ5.globalErrorHandlerState).push('GlobalErrorHandler', null, event.reason.name, event.reason.message, event.reason.stack);
    else if (event.reason) try {
        const hint = JSON.stringify(event.reason).slice(0, 50);
        (0, $5dRZ5.globalErrorHandlerState).push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`);
    // eslint-disable-next-line no-empty
    } catch  {}
}
function $2eb67ebc7290274a$export$2e2bcd8739ae039() {
    if ((0, $5dRZ5.globalErrorHandlerState).shouldInitialize) {
        (0, $dqdTY.bind)(window, {
            type: 'error',
            listener: (event)=>$2eb67ebc7290274a$var$handleError(event)
        });
        (0, $dqdTY.bind)(window, {
            type: 'unhandledrejection',
            listener: $2eb67ebc7290274a$var$handlePromiseRejection
        });
        (0, $5dRZ5.globalErrorHandlerState).shouldInitialize = false;
    }
}

});
parcelRegister("5dRZ5", function(module, exports) {
$parcel$export(module.exports, "globalErrorHandlerState", () => $7fb485e0bd4fcb7b$export$f22470fc43ac872f);
const $7fb485e0bd4fcb7b$var$errors = [];
const $7fb485e0bd4fcb7b$export$f22470fc43ac872f = {
    shouldInitialize: true,
    globalCount: 0,
    errors: $7fb485e0bd4fcb7b$var$errors,
    push: (name, labelStack, errorType, errorMessage, errorStack)=>{
        $7fb485e0bd4fcb7b$var$errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack
        });
    }
};

});


parcelRegister("1gXPF", function(module, exports) {
$parcel$export(module.exports, "reportError", () => $6a62c862633c3fbe$export$b33b857ad1d9900e);
$parcel$export(module.exports, "installErrorHandler", () => $6a62c862633c3fbe$export$abd5747ea77ecab9);

var $llCao = parcelRequire("llCao");
const $6a62c862633c3fbe$var$buffer = [];
let $6a62c862633c3fbe$var$push = (payload)=>{
    $6a62c862633c3fbe$var$buffer.push(payload);
};
function $6a62c862633c3fbe$export$b33b857ad1d9900e(payload) {
    $6a62c862633c3fbe$var$push(payload);
}
function $6a62c862633c3fbe$export$abd5747ea77ecab9(handler) {
    if ((0, $llCao.fg)('moving_jira_entry-points_api_under_platform')) {
        $6a62c862633c3fbe$var$push = handler;
        $6a62c862633c3fbe$var$buffer.forEach((payload)=>handler(payload));
        $6a62c862633c3fbe$var$buffer.length = 0;
    }
}

});

parcelRegister("9G3Hh", function(module, exports) {
$parcel$export(module.exports, "default", () => $33b0995c03dc0b80$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $lNjwN = parcelRequire("lNjwN");

var $dOQFV = parcelRequire("dOQFV");
var $33b0995c03dc0b80$export$2e2bcd8739ae039 = (0, $lNjwN.default);

});
parcelRegister("dOQFV", function(module, exports) {
$parcel$export(module.exports, "useInteractionContext", () => $05aebf58e381eeae$export$11bcb6e9af2aca35);

var $fsvuC = parcelRequire("fsvuC");

var $lNjwN = parcelRequire("lNjwN");
function $05aebf58e381eeae$export$11bcb6e9af2aca35() {
    return (0, $fsvuC.useContext)((0, $lNjwN.default));
}

});


parcelRegister("22i4U", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b0e8d82df51b34d$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $fsvuC = parcelRequire("fsvuC");

var $9LG40 = parcelRequire("9LG40");



// We use a context to allow modals to have their own lifecycle
const $2b0e8d82df51b34d$var$interactionContext = (0, $fsvuC.createContext)((0, $9LG40.default));
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$2b0e8d82df51b34d$export$2e2bcd8739ae039 = $2b0e8d82df51b34d$var$interactionContext;

});

parcelRegister("3eqwL", function(module, exports) {
$parcel$export(module.exports, "BMEventsType", () => $8b888618163c9132$export$9c73e297d4be9159);
$parcel$export(module.exports, "StorableBMEventsType", () => $8b888618163c9132$export$9b7037ec30489597);
$parcel$export(module.exports, "BMPageLoadMetrics", () => $8b888618163c9132$export$74c1fb0997d51e2a);
$parcel$export(module.exports, "BMPageSegmentLoadMetrics", () => $8b888618163c9132$export$88195ac8200d03a6);
$parcel$export(module.exports, "BMInteractionMetrics", () => $8b888618163c9132$export$6e28252a002afdb2);
$parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", () => $8b888618163c9132$export$474154836bfd8dd9);
$parcel$export(module.exports, "PageVisibleFields", () => $8b888618163c9132$export$e89802082dab5633);
$parcel$export(module.exports, "PageVisibleValueOrigin", () => $8b888618163c9132$export$983b017156c2aee2);
$parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", () => $8b888618163c9132$export$60c0193054fc3040);
var $8b888618163c9132$export$9c73e297d4be9159 = /*#__PURE__*/ function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    return BMEventsType;
}({});
var $8b888618163c9132$export$9b7037ec30489597 = /*#__PURE__*/ function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    return StorableBMEventsType;
}({});
var $8b888618163c9132$export$74c1fb0997d51e2a = /*#__PURE__*/ function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
    return BMPageLoadMetrics;
}({});
var $8b888618163c9132$export$88195ac8200d03a6 = /*#__PURE__*/ function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
    return BMPageSegmentLoadMetrics;
}({});
var $8b888618163c9132$export$6e28252a002afdb2 = /*#__PURE__*/ function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
    return BMInteractionMetrics;
}({});
var $8b888618163c9132$export$474154836bfd8dd9 = /*#__PURE__*/ function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    return PageSegmentPageLoadMetricsOptions;
}({});
var $8b888618163c9132$export$e89802082dab5633 = /*#__PURE__*/ function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    return PageVisibleFields;
}({});
var $8b888618163c9132$export$983b017156c2aee2 = /*#__PURE__*/ function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    return PageVisibleValueOrigin;
}({});
var $8b888618163c9132$export$60c0193054fc3040 = /*#__PURE__*/ function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    return IncludeSSRFeatureFlagsConfig;
}({});

});

parcelRegister("e4IhG", function(module, exports) {
$parcel$export(module.exports, "Route", () => $55c97625eaa7a25f$export$e7b0ac011bb776c6);
const $55c97625eaa7a25f$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});

parcelRegister("f3izM", function(module, exports) {
$parcel$export(module.exports, "submitter", () => $5257d80167ab57b4$export$c21a25872e3f5a2b);

var $8IAtM = parcelRequire("8IAtM");

var $3eqwL = parcelRequire("3eqwL");

var $7E9pN = parcelRequire("7E9pN");

var $gvHxb = parcelRequire("gvHxb");
const $5257d80167ab57b4$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure (config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $gvHxb.makeShareableGlobalConfig)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $3eqwL.PageVisibleFields).pageVisibleState;
    },
    setDebug (debug) {
        this.debug = debug;
    },
    async queue (data) {
        if (this.config.enableReactUFOTracker) (0, $8IAtM.addBrowserMetricEvent)(data);
        if (!this.config.configChunk) {
            // eslint-disable-next-line no-console
            this.debug && console.warn('Submitter is not configured');
            return null;
        }
        const chunk = await this.config.configChunk;
        const payload = await (0, $7E9pN.eventDataProcessor)(chunk[data.config.type], data);
        if (payload === null) return;
        if (this.config.gasv3 !== undefined) {
            const client = await this.config.gasv3;
            const attributes = {
                task: payload['event:key'],
                properties: payload
            };
            client && client.sendOperationalEvent({
                actionSubject: 'performance',
                attributes: attributes,
                source: 'performance',
                action: 'measured'
            });
        }
        return;
    }
};

});
parcelRegister("7E9pN", function(module, exports) {
$parcel$export(module.exports, "eventDataProcessor", () => $89d372a33fd734a7$export$896b6e121bbaec25);

var $lPV2J = parcelRequire("lPV2J");

var $fKyz0 = parcelRequire("fKyz0");

var $fLeeg = parcelRequire("fLeeg");

var $9f2WA = parcelRequire("9f2WA");

var $4ZRJD = parcelRequire("4ZRJD");

var $aWGcB = parcelRequire("aWGcB");

var $87Ubt = parcelRequire("87Ubt");

var $dVQj2 = parcelRequire("dVQj2");

var $feXow = parcelRequire("feXow");

var $8ug33 = parcelRequire("8ug33");

var $8JgMT = parcelRequire("8JgMT");

var $d6Usv = parcelRequire("d6Usv");

var $6lEjL = parcelRequire("6lEjL");

var $19SZ2 = parcelRequire("19SZ2");

var $iIVEb = parcelRequire("iIVEb");

var $jgaLD = parcelRequire("jgaLD");

var $4QuBX = parcelRequire("4QuBX");

var $bD5N1 = parcelRequire("bD5N1");

var $97KjA = parcelRequire("97KjA");

var $1ojXA = parcelRequire("1ojXA");

var $5WP5Q = parcelRequire("5WP5Q");

var $foTH7 = parcelRequire("foTH7");

var $kKE2E = parcelRequire("kKE2E");

var $215FL = parcelRequire("215FL");

var $aZkCv = parcelRequire("aZkCv");

var $MjVw6 = parcelRequire("MjVw6");

var $llUza = parcelRequire("llUza");

var $fCWSX = parcelRequire("fCWSX");

var $bKxXc = parcelRequire("bKxXc");

var $149yy = parcelRequire("149yy");

var $lTqI0 = parcelRequire("lTqI0");

var $jm7cK = parcelRequire("jm7cK");

var $1g4QV = parcelRequire("1g4QV");

var $kAA8W = parcelRequire("kAA8W");

var $kCvPo = parcelRequire("kCvPo");

var $dVpzR = parcelRequire("dVpzR");

var $2SPO3 = parcelRequire("2SPO3");

var $9b2ni = parcelRequire("9b2ni");

var $fj1Fd = parcelRequire("fj1Fd");

var $3eqwL = parcelRequire("3eqwL");
const $89d372a33fd734a7$var$defaultSet = [
    (0, $8JgMT.eventKey),
    (0, $4QuBX.eventType),
    (0, $19SZ2.eventProduct),
    (0, $6lEjL.eventPopulation),
    (0, $jgaLD.eventRoute),
    (0, $feXow.eventId),
    (0, $d6Usv.eventLocalTime),
    (0, $iIVEb.eventRegion),
    (0, $4ZRJD.appFramework),
    (0, $aWGcB.appVersion),
    (0, $87Ubt.bmVersion),
    (0, $jm7cK.telemetryBrowser),
    (0, $1g4QV.telemetryCpu),
    (0, $kAA8W.telemetryMemory),
    (0, $kCvPo.telemetryNetwork),
    (0, $dVQj2.customData),
    (0, $bD5N1.featureFlags),
    (0, $97KjA.hostname),
    (0, $bKxXc.productCustomData),
    (0, $dVpzR.appTimings),
    (0, $9b2ni.resourceTimings),
    (0, $fj1Fd.traceContext)
];
const $89d372a33fd734a7$var$pageLoadCommon = [
    ...$89d372a33fd734a7$var$defaultSet,
    (0, $llUza.pageVisibleState),
    (0, $fCWSX.pageVisibleValue),
    (0, $8ug33.eventInitial),
    (0, $215FL.pageLoadMetrics),
    (0, $2SPO3.bundleEvalTimings)
];
const $89d372a33fd734a7$var$initialPageLoadSet = [
    ...$89d372a33fd734a7$var$pageLoadCommon,
    (0, $5WP5Q.initialPageLoadMetrics),
    (0, $kKE2E.navigationMetrics),
    (0, $lTqI0.ssrSuccess),
    (0, $149yy.ssrFeatureFlags)
];
const $89d372a33fd734a7$var$spaTransitionSet = [
    ...$89d372a33fd734a7$var$pageLoadCommon
];
const $89d372a33fd734a7$var$pageSegmentLoadSet = [
    ...$89d372a33fd734a7$var$defaultSet,
    (0, $aZkCv.pageSegmentLoadMetrics),
    (0, $llUza.pageVisibleState),
    (0, $fCWSX.pageVisibleValue),
    (0, $8ug33.eventInitial),
    (0, $2SPO3.bundleEvalTimings)
];
const $89d372a33fd734a7$var$interactionSet = [
    ...$89d372a33fd734a7$var$defaultSet,
    (0, $llUza.pageVisibleState),
    (0, $fCWSX.pageVisibleValue),
    (0, $foTH7.interactionMetrics)
];
const $89d372a33fd734a7$var$customMetricSet = [
    ...$89d372a33fd734a7$var$defaultSet,
    (0, $llUza.pageVisibleState),
    (0, $fCWSX.pageVisibleValue),
    (0, $1ojXA.customEventMetrics)
];
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
const $89d372a33fd734a7$var$webVitalsMetricSet = [
    ...$89d372a33fd734a7$var$defaultSet,
    (0, $MjVw6.webVitalsMetrics)
];
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
const $89d372a33fd734a7$var$waitForCLS = (delay = (0, $lPV2J.clsWaitTimeMs) + 500)=>{
    return new Promise((resolve)=>setTimeout(resolve, delay));
};
const $89d372a33fd734a7$export$896b6e121bbaec25 = async (globalConfig, data)=>{
    if (data.start === null || data.stop === null) {
        (0, $fKyz0.logger).log(`eventDataProcessor: Metric "${data.key}" start or stop are incorrect; start: ${data.start}; stop: ${data.stop}`);
        return null;
    }
    let set = [];
    if (data.config.type === (0, $3eqwL.BMEventsType).PAGE_LOAD && (0, $fLeeg.isPageLoadMetricData)(data) && data.isInitial) set = $89d372a33fd734a7$var$initialPageLoadSet;
    if (data.config.type === (0, $3eqwL.BMEventsType).PAGE_LOAD && (0, $fLeeg.isPageLoadMetricData)(data) && !data.isInitial) set = $89d372a33fd734a7$var$spaTransitionSet;
    if (data.config.type === (0, $3eqwL.BMEventsType).PAGE_SEGMENT_LOAD && (0, $9f2WA.isPageSegmentLoadMetricData)(data)) set = $89d372a33fd734a7$var$pageSegmentLoadSet;
    if (data.config.type === (0, $3eqwL.BMEventsType).INLINE_RESULT) set = $89d372a33fd734a7$var$interactionSet;
    if (data.config.type === (0, $3eqwL.BMEventsType).CUSTOM) set = $89d372a33fd734a7$var$customMetricSet;
    if (data.config.type === (0, $3eqwL.BMEventsType).WEB_VITALS) {
        set = $89d372a33fd734a7$var$webVitalsMetricSet;
        // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
        await $89d372a33fd734a7$var$waitForCLS();
    }
    //TODO if type is different - do not send at all
    const plugins = [];
    for (const plugin of set){
        const result = await plugin(data.config, data, globalConfig);
        if (result) plugins.push(result);
    }
    const pluginResults = await Promise.all(plugins);
    const generated = {};
    pluginResults.forEach((pluginResult)=>{
        if (pluginResult === null) return;
        Object.keys(pluginResult).forEach((key)=>{
            const keyResult = pluginResult[key];
            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
        });
    });
    return generated;
};

});
parcelRegister("lPV2J", function(module, exports) {
$parcel$export(module.exports, "restrictedTimingKeys", () => $f3e3b8f2a4a95b50$export$1d17377365286b00);
$parcel$export(module.exports, "clsWaitTimeMs", () => $f3e3b8f2a4a95b50$export$df21d285cfcda81e);
const $f3e3b8f2a4a95b50$export$1d17377365286b00 = [
    'ssr'
];
const $f3e3b8f2a4a95b50$export$df21d285cfcda81e = 7500;

});

parcelRegister("fKyz0", function(module, exports) {
$parcel$export(module.exports, "logger", () => $80ee6feadb975ba2$export$af88d00dbe7f521);
const $80ee6feadb975ba2$export$af88d00dbe7f521 = {
    enabled: false,
    enable () {
        this.enabled = true;
    },
    log (...args) {
        if (this.enabled) // eslint-disable-next-line no-console
        console.log('BM log: ', ...args);
    },
    logCond (condition, ...args) {
        if (this.enabled && condition && args.length > 1) this.log(...args);
    }
};

});

parcelRegister("fLeeg", function(module, exports) {
$parcel$export(module.exports, "isPageLoadMetricData", () => $e68f27fe44ec7e9e$export$b0e12e7abb0bff11);

var $3eqwL = parcelRequire("3eqwL");
const $e68f27fe44ec7e9e$export$b0e12e7abb0bff11 = (data)=>{
    return data.type === (0, $3eqwL.BMEventsType).PAGE_LOAD;
};

});

parcelRegister("9f2WA", function(module, exports) {
$parcel$export(module.exports, "isPageSegmentLoadMetricData", () => $7c74ebc240fa6f46$export$83d0099ee6dbb5b0);

var $3eqwL = parcelRequire("3eqwL");
const $7c74ebc240fa6f46$export$83d0099ee6dbb5b0 = (data)=>{
    return data.type === (0, $3eqwL.BMEventsType).PAGE_SEGMENT_LOAD;
};

});

parcelRegister("4ZRJD", function(module, exports) {
$parcel$export(module.exports, "appFramework", () => $37272cb4c0e309a1$export$e34e4529b979f74c);
const $37272cb4c0e309a1$export$e34e4529b979f74c = (_config, _data, globalConfig)=>{
    if (!globalConfig.app.framework) return null;
    return {
        'app:framework:name': globalConfig.app.framework.name,
        'app:framework:version': globalConfig.app.framework.version
    };
};

});

parcelRegister("aWGcB", function(module, exports) {
$parcel$export(module.exports, "appVersion", () => $99814bf2391fc879$export$82ae485178b37419);
const $99814bf2391fc879$export$82ae485178b37419 = (_config, _data, globalConfig)=>{
    const pluginData = {
        'app:web:version': globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
    return pluginData;
};

});

parcelRegister("87Ubt", function(module, exports) {
$parcel$export(module.exports, "bmVersion", () => $8386c14c8a68d8ec$export$5cafa465fc876895);
const $8386c14c8a68d8ec$export$5cafa465fc876895 = ()=>{
    return {
        'bm:version': 3
    };
};

});

parcelRegister("dVQj2", function(module, exports) {
$parcel$export(module.exports, "customData", () => $6449abe8fc788178$export$f7e743c7db162193);
const $6449abe8fc788178$export$f7e743c7db162193 = (_config, data)=>{
    const custom = {};
    let changed = false;
    if (data.custom) Object.entries(data.custom).forEach(([key, value])=>{
        changed = true;
        custom[`custom:${key}`] = value;
    });
    return changed ? custom : null;
};

});

parcelRegister("feXow", function(module, exports) {
$parcel$export(module.exports, "eventId", () => $90e2ca2d003b336c$export$aed28df7ac07d79a);
const $90e2ca2d003b336c$export$aed28df7ac07d79a = (config)=>{
    return {
        'event:id': config.key
    };
};

});

parcelRegister("8ug33", function(module, exports) {
$parcel$export(module.exports, "eventInitial", () => $c5460575fdaf6ad0$export$fa8e91d436b3ef8b);

var $fLeeg = parcelRequire("fLeeg");

var $9f2WA = parcelRequire("9f2WA");
const $c5460575fdaf6ad0$export$fa8e91d436b3ef8b = (_config, data)=>{
    if (!(0, $fLeeg.isPageLoadMetricData)(data) && !(0, $9f2WA.isPageSegmentLoadMetricData)(data)) return null;
    return {
        'event:initial': data.isInitial
    };
};

});

parcelRegister("8JgMT", function(module, exports) {
$parcel$export(module.exports, "eventKey", () => $57dafff20938c22c$export$10be2d3a558d3f88);

var $3OHiU = parcelRequire("3OHiU");
const $57dafff20938c22c$export$10be2d3a558d3f88 = (config, _data, globalConfig)=>{
    return {
        'event:key': `${globalConfig.product}.fe.${(0, $3OHiU.mapEventType)(config.type)}.${config.key}`
    };
};

});
parcelRegister("3OHiU", function(module, exports) {
$parcel$export(module.exports, "mapEventType", () => $545fa4b315820644$export$b334d07f11140768);

var $3eqwL = parcelRequire("3eqwL");
const $545fa4b315820644$export$b334d07f11140768 = (type)=>{
    switch(type){
        case (0, $3eqwL.BMEventsType).CUSTOM:
            return (0, $3eqwL.StorableBMEventsType).CUSTOM;
        case (0, $3eqwL.BMEventsType).INLINE_RESULT:
            return (0, $3eqwL.StorableBMEventsType).INLINE_RESULT;
        case (0, $3eqwL.BMEventsType).PAGE_LOAD:
            return (0, $3eqwL.StorableBMEventsType).PAGE_LOAD;
        case (0, $3eqwL.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $3eqwL.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $3eqwL.BMEventsType).WEB_VITALS:
            return (0, $3eqwL.StorableBMEventsType).WEB_VITALS;
        default:
            return 'unknown';
    }
};

});


parcelRegister("d6Usv", function(module, exports) {
$parcel$export(module.exports, "eventLocalTime", () => $8bab1e71e985b46c$export$5219854ae7ec45da);

var $d9r5V = parcelRequire("d9r5V");
const $8bab1e71e985b46c$export$5219854ae7ec45da = ()=>({
        'event:localHour': parseInt((0, $d9r5V.default)(new Date(), 'H'), 10),
        'event:localDayOfWeek': parseInt((0, $d9r5V.default)(new Date(), 'i'), 10)
    });

});

parcelRegister("6lEjL", function(module, exports) {
$parcel$export(module.exports, "eventPopulation", () => $d5fff696653c977c$export$9086dbeda9b1d633);
const $d5fff696653c977c$export$9086dbeda9b1d633 = (_config, _data, globalConfig)=>{
    if (!globalConfig.population) return {};
    return {
        'event:population': `${globalConfig.population}`
    };
};

});

parcelRegister("19SZ2", function(module, exports) {
$parcel$export(module.exports, "eventProduct", () => $d4548045332b0bc2$export$a7df4e8088db8843);
const $d4548045332b0bc2$export$a7df4e8088db8843 = (_config, _data, globalConfig)=>{
    return {
        'event:product': `${globalConfig.product}`
    };
};

});

parcelRegister("iIVEb", function(module, exports) {
$parcel$export(module.exports, "eventRegion", () => $ac7f0b1beb2c99be$export$d0117b71adcdebc0);
const $ac7f0b1beb2c99be$export$d0117b71adcdebc0 = (_config, _data, globalConfig)=>{
    return {
        'event:region': `${globalConfig.region}`
    };
};

});

parcelRegister("jgaLD", function(module, exports) {
$parcel$export(module.exports, "eventRoute", () => $62080a1a4bac8abc$export$44d3627af289ca16);
const $62080a1a4bac8abc$export$44d3627af289ca16 = (_config, data)=>{
    if (!data.route) return null;
    return {
        'event:route': data.route
    };
};

});

parcelRegister("4QuBX", function(module, exports) {
$parcel$export(module.exports, "eventType", () => $9e6b2fc1e2b276d8$export$4c045e605d532c98);

var $3OHiU = parcelRequire("3OHiU");
const $9e6b2fc1e2b276d8$export$4c045e605d532c98 = (config)=>{
    return {
        'event:type': (0, $3OHiU.mapEventType)(config.type)
    };
};

});

parcelRegister("bD5N1", function(module, exports) {
$parcel$export(module.exports, "featureFlags", () => $95ef9f1b17384374$export$e62953d023125748);
const $95ef9f1b17384374$export$e62953d023125748 = (config, _data, globalConfig)=>{
    const localFeatureFlags = config.featureFlags?.reduce((acc, ffName)=>{
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {}) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: {
            ...localFeatureFlags,
            ...globalConfig.featureFlags
        }
    };
};

});

parcelRegister("97KjA", function(module, exports) {
$parcel$export(module.exports, "hostname", () => $2fc9b9f799cb71e9$export$640106f6dc7d2706);
const $2fc9b9f799cb71e9$export$640106f6dc7d2706 = (_config, _data, globalConfig)=>{
    return {
        hostname: globalConfig.hostname
    };
};

});

parcelRegister("1ojXA", function(module, exports) {
$parcel$export(module.exports, "customEventMetrics", () => $a0515c23961f35a0$export$cab039265c52a2e9);

var $k0enD = parcelRequire("k0enD");
const $a0515c23961f35a0$export$cab039265c52a2e9 = (config, data, globalConfig)=>{
    if (!(0, $k0enD.isCustomConfig)(config)) return null;
    const payload = {
        'metric:duration': Math.round(data.stop - data.start)
    };
    if (config.slo?.threshold !== undefined) {
        payload['metric:duration:slo'] = payload['metric:duration'] <= config.slo?.threshold;
        payload['metric:duration:slo:threshold'] = config.slo?.threshold;
    }
    if (config.histogram?.duration) payload['metric:duration:histogramBuckets'] = config.histogram.duration;
    else if (globalConfig.histogram) payload['metric:duration:histogramBuckets'] = globalConfig.histogram.duration;
    return payload;
};

});
parcelRegister("k0enD", function(module, exports) {
$parcel$export(module.exports, "isCustomConfig", () => $82d9ed0c8ec1cbc1$export$b493eb8b2ba87421);

var $3eqwL = parcelRequire("3eqwL");
const $82d9ed0c8ec1cbc1$export$b493eb8b2ba87421 = (data)=>{
    return data.type === (0, $3eqwL.BMEventsType).CUSTOM;
};

});


parcelRegister("5WP5Q", function(module, exports) {
$parcel$export(module.exports, "initialPageLoadMetrics", () => $683c697dbfe432e7$export$cc95aa3f6ea8e5cb);
const $683c697dbfe432e7$export$cc95aa3f6ea8e5cb = ()=>{
    const metrics = {};
    performance.getEntriesByType('paint').forEach((entry)=>{
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    return metrics;
};

});

parcelRegister("foTH7", function(module, exports) {
$parcel$export(module.exports, "interactionMetrics", () => $4d4ba0a546431b1a$export$86db56030b57ba34);

var $jDC4H = parcelRequire("jDC4H");

var $Zckup = parcelRequire("Zckup");

var $3eqwL = parcelRequire("3eqwL");
const $4d4ba0a546431b1a$export$86db56030b57ba34 = (config, data, globalConfig)=>{
    if (!(0, $Zckup.isInteractionConfig)(config)) return null;
    const result = {
        'metric:result': Math.round(data.stop - data.start)
    };
    if (config.histogram?.result) result['metric:result:histogramBuckets'] = config.histogram.result;
    else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result['metric:result:histogramBuckets'] = histogram[(0, $3eqwL.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $jDC4H.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result['metric:result:slo'] = result['metric:result'] <= config.slo.result.threshold;
        result['metric:result:slo:threshold'] = config.slo.result.threshold;
    }
    if (data.marks['feedback']) {
        result['metric:response'] = Math.round((data.marks['feedback'] || data.stop) - data.start);
        if (config.histogram?.response) result['metric:response:histogramBuckets'] = config.histogram[(0, $3eqwL.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            if (histogram.result !== undefined) result['metric:response:histogramBuckets'] = histogram[(0, $3eqwL.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $jDC4H.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result['metric:response:slo'] = result['metric:response'] <= config.slo.response.threshold;
            result['metric:response:slo:threshold'] = config.slo.response.threshold;
        }
    }
    return result;
};

});
parcelRegister("jDC4H", function(module, exports) {
$parcel$export(module.exports, "isInteractionMetricsSlo", () => $62b353b048ca2b43$export$b10c1d9a7db7765b);
const $62b353b048ca2b43$export$b10c1d9a7db7765b = (data)=>{
    const obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};

});

parcelRegister("Zckup", function(module, exports) {
$parcel$export(module.exports, "isInteractionConfig", () => $0a5b1a4cfe0c360e$export$ae68674b6a9353be);

var $3eqwL = parcelRequire("3eqwL");
const $0a5b1a4cfe0c360e$export$ae68674b6a9353be = (data)=>{
    return data.type === (0, $3eqwL.BMEventsType).INLINE_RESULT;
};

});


parcelRegister("kKE2E", function(module, exports) {
$parcel$export(module.exports, "navigationMetrics", () => $b4c18ed1bdb8d18e$export$b88d990436be0f8a);
const $b4c18ed1bdb8d18e$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("215FL", function(module, exports) {
$parcel$export(module.exports, "pageLoadMetrics", () => $66bb7bdddf5a0f5b$export$2878bf482e539059);

var $1316H = parcelRequire("1316H");

var $b94kX = parcelRequire("b94kX");

var $3eqwL = parcelRequire("3eqwL");
const $66bb7bdddf5a0f5b$var$getThreshold = (isInitial, metric)=>{
    return (0, $1316H.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $66bb7bdddf5a0f5b$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $66bb7bdddf5a0f5b$export$2878bf482e539059 = (config, data, globalConfig)=>{
    if (!(0, $b94kX.isPageLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page load data for non-page-load config');
    const fmp = data.marks[(0, $3eqwL.BMPageLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $66bb7bdddf5a0f5b$var$getHistogram(data.isInitial, (0, $3eqwL.BMPageLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $66bb7bdddf5a0f5b$var$getHistogram(data.isInitial, (0, $3eqwL.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $66bb7bdddf5a0f5b$var$getHistogram(data.isInitial, (0, $3eqwL.BMPageLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $66bb7bdddf5a0f5b$var$getHistogram(data.isInitial, (0, $3eqwL.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        const threshold = $66bb7bdddf5a0f5b$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo && config.slo.tti) {
        const threshold = $66bb7bdddf5a0f5b$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    return result;
};

});
parcelRegister("1316H", function(module, exports) {
$parcel$export(module.exports, "isDetailedPageLoadSlo", () => $76a340d63c4b135c$export$5866f95702a15142);
const $76a340d63c4b135c$export$5866f95702a15142 = (data)=>{
    return Boolean(data.initial);
};

});

parcelRegister("b94kX", function(module, exports) {
$parcel$export(module.exports, "isPageLoadConfig", () => $a237e97f43e4aeef$export$8672fa27ba8bba88);

var $3eqwL = parcelRequire("3eqwL");
const $a237e97f43e4aeef$export$8672fa27ba8bba88 = (data)=>{
    return data.type === (0, $3eqwL.BMEventsType).PAGE_LOAD;
};

});


parcelRegister("aZkCv", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoadMetrics", () => $fdda6c5a728331c5$export$ba86cb47f2f22db5);

var $eDFAX = parcelRequire("eDFAX");

var $7hB4W = parcelRequire("7hB4W");

var $es0Kq = parcelRequire("es0Kq");

var $3eqwL = parcelRequire("3eqwL");
const $fdda6c5a728331c5$var$getThreshold = (isInitial, metric)=>{
    return (0, $eDFAX.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $fdda6c5a728331c5$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $fdda6c5a728331c5$export$ba86cb47f2f22db5 = (config, data, globalConfig)=>{
    if (!(0, $7hB4W.isPageSegmentLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page segment load data for non-page-segment-load config');
    const fmp = data.marks[(0, $3eqwL.BMPageSegmentLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $fdda6c5a728331c5$var$getHistogram(data.isInitial, (0, $3eqwL.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $fdda6c5a728331c5$var$getHistogram(data.isInitial, (0, $3eqwL.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $fdda6c5a728331c5$var$getHistogram(data.isInitial, (0, $3eqwL.BMPageSegmentLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $fdda6c5a728331c5$var$getHistogram(data.isInitial, (0, $3eqwL.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if (config.slo?.fmp) {
        const threshold = $fdda6c5a728331c5$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo?.tti) {
        const threshold = $fdda6c5a728331c5$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    if (config.includePageLoadTimings === (0, $3eqwL.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $3eqwL.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        const pageLoadData = (0, $es0Kq.pageLoadMetaMetric).getData();
        const fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $3eqwL.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        const tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result['pageLoad'] = {
            fmp: fmp,
            tti: tti
        };
    }
    return result;
};

});
parcelRegister("eDFAX", function(module, exports) {
$parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", () => $b16f5e7d3a36817e$export$f087a59bd717e49d);
const $b16f5e7d3a36817e$export$f087a59bd717e49d = (data)=>{
    return Boolean(data.initial);
};

});

parcelRegister("7hB4W", function(module, exports) {
$parcel$export(module.exports, "isPageSegmentLoadConfig", () => $2fd289f1efeff409$export$abe063537ef4987b);

var $3eqwL = parcelRequire("3eqwL");
const $2fd289f1efeff409$export$abe063537ef4987b = (data)=>{
    return data.type === (0, $3eqwL.BMEventsType).PAGE_SEGMENT_LOAD;
};

});

parcelRegister("es0Kq", function(module, exports) {
$parcel$export(module.exports, "pageLoadMetaMetric", () => $54467fc6ef0efe69$export$24b7a1a311eb05dc);

var $3eqwL = parcelRequire("3eqwL");

var $5xYV9 = parcelRequire("5xYV9");

var $97FbR = parcelRequire("97FbR");
class $54467fc6ef0efe69$export$9609608c00ea5077 extends (0, $97FbR.BasePageLoadMetric) {
    startPageLoad({ cancelStarted: cancelStarted, ...startPageLoadParams } = {
        isInitial: false,
        cancelStarted: false
    }) {
        if (cancelStarted || this.state !== (0, $5xYV9.MetricState).STARTED) super.startPageLoad(startPageLoadParams);
    }
    setActive(metric) {
        this.activePageLoadMetric = metric;
    }
    setDebug(debug) {
        this.config.debug = debug;
    }
    isDebugMode() {
        return this.config.debug;
    }
    isInitialLoad() {
        return this.isInitial;
    }
    clear() {
        this.activePageLoadMetric && this.activePageLoadMetric.cancel();
        super.clear();
    }
    include(metric) {
        if (!this.config.include) this.config.include = [
            metric
        ];
        else this.config.include.push(metric);
    }
    experimental__addExplicitTiming(name, timing) {
        if (this.explicitTimings === null) this.explicitTimings = {};
        this.explicitTimings[name] = timing;
    }
    constructor(...args){
        super(...args), this.activePageLoadMetric = null;
    }
}
const $54467fc6ef0efe69$export$24b7a1a311eb05dc = new $54467fc6ef0efe69$export$9609608c00ea5077({
    type: (0, $3eqwL.BMEventsType).PAGE_LOAD,
    key: 'page_load_meta_metric'
});

});
parcelRegister("5xYV9", function(module, exports) {
$parcel$export(module.exports, "MetricState", () => $3d86e13652d5911f$export$1e458f18c0c7bfe3);
$parcel$export(module.exports, "PageVisibleState", () => $3d86e13652d5911f$export$a12c67b37a306b13);
$parcel$export(module.exports, "BaseMetric", () => $3d86e13652d5911f$export$2bce4ffdd840e878);

var $llCao = parcelRequire("llCao");

var $4IreF = parcelRequire("4IreF");

var $iznU1 = parcelRequire("iznU1");

var $iCGBp = parcelRequire("iCGBp");

var $2k4bX = parcelRequire("2k4bX");

var $aWuej = parcelRequire("aWuej");

var $lPV2J = parcelRequire("lPV2J");

var $fKyz0 = parcelRequire("fKyz0");

var $6judq = parcelRequire("6judq");

var $fNKSo = parcelRequire("fNKSo");
var $3d86e13652d5911f$export$1e458f18c0c7bfe3 = /*#__PURE__*/ function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
    return MetricState;
}({});
var $3d86e13652d5911f$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
    return PageVisibleState;
}({});
function $3d86e13652d5911f$var$getPageVisibleState() {
    return typeof document !== 'undefined' && document.visibilityState === 'visible' ? "visible" : "hidden";
}
class $3d86e13652d5911f$export$2bce4ffdd840e878 {
    static{
        this.FMP = 'fmp';
    }
    constructor(config){
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.onStopCallbacks = [];
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.untilOnStopCallback = null;
        this.pageVisibleState = $3d86e13652d5911f$var$getPageVisibleState();
        this.traceContext = null;
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = "mixed";
        };
        this.config = config;
        this.key = config.key.replace(/ /gi, '-');
        this.type = config.type;
        this.config.timings?.forEach((entry)=>{
            if ((0, $lPV2J.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn(`Entry ${entry.key} is restricted and has been renamed to custom__${entry.key}`);
                entry.key = `custom__${entry.key}`;
            }
        });
    }
    get untilMetrics() {
        const { until: until } = this.config;
        if (!until) return [];
        else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
        return this.getConfiguredUntilMetricArray([
            until
        ]);
    }
    start({ startTime: startTime = window.performance.now() } = {}) {
        this.clear();
        (0, $fKyz0.logger).logCond(!!this.config.debug, this.key, startTime);
        this.state = "started";
        this.startTime = startTime;
        this.pageVisibleState = $3d86e13652d5911f$var$getPageVisibleState();
        (0, $6judq.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
        this.watchUntil();
        this.startTrace(this.key);
    }
    stop(stopArguments = {}) {
        const { stopTime: stopTime = window.performance.now() } = stopArguments;
        if (this.state !== "started" || this.startTime === null) {
            (0, $fKyz0.logger).log(`metric ${this.config.key} has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopTime < this.startTime) {
            (0, $fKyz0.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${this.startTime}; stopTime: ${stopTime}`);
            return false;
        }
        this.stopTime = stopTime;
        this.state = "finished";
        this.handleStop(stopArguments);
        (0, $6judq.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        this.stopTrace();
        return true;
    }
    startTrace(metricKey) {
        if ((0, $llCao.fg)('uip_bm3_tracing')) {
            let traceContext = (0, $2k4bX.getActiveTrace)();
            if (!traceContext) {
                traceContext = {
                    traceId: (0, $iCGBp.generateTraceId)(),
                    spanId: (0, $iznU1.generateSpanId)()
                };
                (0, $aWuej.setActiveTrace)(traceContext.traceId, traceContext.spanId, 'bm3.' + metricKey);
            }
            this.traceContext = traceContext;
        }
    }
    stopTrace() {
        if ((0, $llCao.fg)('uip_bm3_tracing')) (0, $4IreF.clearActiveTrace)();
    }
    handleStop(stopArguments) {
        const { customData: customData = null } = stopArguments;
        if (customData) this.custom = {
            ...this.custom,
            ...customData
        };
        this.config.include && this.config.include.forEach((metric)=>{
            const included = metric.getData();
            if (included.state === "finished" && included.start !== null && included.start >= (this.startTime || 0)) this.addSubMetric(metric.getData());
        });
        this.onStopCallbacks.forEach(([success])=>{
            success(stopArguments);
        });
        this.onStopCallbacks = [];
        (0, $fKyz0.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
    }
    mark(mark, timestamp = window.performance.now()) {
        this.marks[mark] = timestamp;
    }
    cancel() {
        if (this.state !== "started") return;
        this.state = "cancelled";
        this.cancelUntil();
        this.onStopCallbacks.forEach(([, cancel])=>{
            cancel();
        });
        this.onStopCallbacks = [];
        (0, $6judq.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
    }
    merge(mergeData) {
        this.state = mergeData.state;
        this.pageVisibleState = mergeData.pageVisibleState;
        this.startTime = mergeData.start;
        this.stopTime = mergeData.stop;
        this.marks = {
            ...this.marks,
            ...mergeData.marks
        };
        this.submetrics = [
            ...this.submetrics,
            ...mergeData.submetrics
        ];
        this.onStopCallbacks = [
            ...this.onStopCallbacks,
            ...mergeData.onStopCallbacks
        ];
    }
    onStop(success, cancel) {
        this.onStopCallbacks.push([
            success,
            cancel
        ]);
    }
    removeOnStopCallback(success) {
        const index = this.onStopCallbacks.findIndex(([successCallback])=>{
            return success === successCallback;
        });
        if (index > -1) this.onStopCallbacks.splice(index, 1);
    }
    getData() {
        return {
            key: this.key,
            state: this.state,
            start: this.startTime,
            stop: this.stopTime,
            //todo ranges
            // ranges: this.makeRanges()
            marks: this.marks,
            // todo make copy
            custom: this.custom,
            submetrics: this.submetrics,
            config: this.config,
            route: this.route,
            pageVisibleState: this.pageVisibleState,
            type: this.config.type,
            ...(0, $llCao.fg)('uip_bm3_tracing') ? {
                traceContext: this.traceContext
            } : {}
        };
    }
    getDataToMerge() {
        return {
            ...this.getData(),
            onStopCallbacks: this.onStopCallbacks
        };
    }
    addSubMetric(data) {
        this.submetrics.push(data);
    }
    /**
	 *
	 * @param metric
	 * The array of Until metrics can be of two types
	 * This function returns an UntilExperience
	 */ getConfiguredUntilMetric(metricOrConfig) {
        return metricOrConfig instanceof $3d86e13652d5911f$export$2bce4ffdd840e878 ? (0, $fNKSo.UntilExperience).fromMetric(metricOrConfig) : (0, $fNKSo.UntilExperience).fromConfig(metricOrConfig);
    }
    getConfiguredUntilMetricArray(metricArray) {
        if (!metricArray.length) return [];
        return metricArray.map((metric)=>this.getConfiguredUntilMetric(metric));
    }
    isUntilFinished() {
        return this.untilMetrics.every((metric)=>metric.experience.getData().state === "finished");
    }
    handleAllUntilFinished() {
        // Order by ascending stop time
        const sorted = [
            ...this.untilMetrics
        ].sort((m1, m2)=>{
            return m1.getDependencyStopTime() - m2.getDependencyStopTime();
        });
        // Find the latest page segment to become fully interactive
        const latestFullyInteractiveSegment = [
            ...this.untilMetrics
        ].reduce((currentLatestSegment, metric)=>{
            const currentLatestStopTime = currentLatestSegment?.getFullyInteractiveStopTime() ?? 0;
            const metricStopTime = metric.getFullyInteractiveStopTime() ?? 0;
            return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
        }, undefined);
        // Accumulate the custom data from each metric, later metrics take priority
        const accumulatedCustomData = {};
        sorted.forEach((metric)=>{
            Object.assign(accumulatedCustomData, metric.experience.getData().custom);
        });
        const latestSegment = sorted[sorted.length - 1];
        const latestFullyInteractiveStopTime = latestFullyInteractiveSegment?.getFullyInteractiveStopTime();
        this.stop({
            stopTime: latestSegment.getDependencyStopTime(),
            customData: {
                ...accumulatedCustomData,
                segment: latestSegment.getKey(),
                segmentOverrided: latestSegment.getIsSegmentLoadOverrided(),
                ...latestFullyInteractiveStopTime ? {
                    latestFullyInteractiveSegment: latestFullyInteractiveSegment?.getKey(),
                    latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                } : {}
            }
        });
    }
    watchUntil() {
        if (!this.untilMetrics.length) return;
        if (this.isUntilFinished()) {
            // Already finished, handle it immediately
            this.handleAllUntilFinished();
            return;
        }
        // If not currently finished, register stop callbacks to re-check
        this.untilOnStopCallback = ()=>{
            if (this.isUntilFinished()) this.handleAllUntilFinished();
        };
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "finished") metric.experience.onStop(this.untilOnStopCallback, ()=>this.cancel());
        });
    }
    cancelUntil() {
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "cancelled" && this.untilOnStopCallback) metric.experience.removeOnStopCallback(this.untilOnStopCallback);
        });
    }
    clear() {
        // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
        this.cancelUntil();
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.pageVisibleState = $3d86e13652d5911f$var$getPageVisibleState();
        this.traceContext = null;
    }
}

});
parcelRegister("4IreF", function(module, exports) {
$parcel$export(module.exports, "clearActiveTrace", () => $d6dceeb449632d6c$export$17ab21d7be720b);

var $iY4Dc = parcelRequire("iY4Dc");
function $d6dceeb449632d6c$export$17ab21d7be720b() {
    (0, $iY4Dc.state).context = null;
}

});

parcelRegister("iznU1", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $8677b8bfb99cc1e6$export$295213bc4d0c54ad);
/**
 * Generates a random 16-character hexadecimal span ID.
 * This is used for creating new span IDs in distributed tracing.
 *
 * @returns A 16-character hexadecimal string
 *
 * @example
 * ```typescript
 * const spanId = generateSpanId(); // e.g., "84a67a1b3ceccf27"
 * ```
 */ function $8677b8bfb99cc1e6$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});

parcelRegister("iCGBp", function(module, exports) {
$parcel$export(module.exports, "generateTraceId", () => $07f7ce389e344fbc$export$dc6d7ea554bcce10);
/**
 * Generates a random 32-character hexadecimal trace ID.
 * This is used for creating new trace IDs in distributed tracing.
 *
 * @returns A 32-character hexadecimal string
 *
 * @example
 * ```typescript
 * const traceId = generateTraceId(); // e.g., "9ad3407c1a7d484b86847e7226e566d3"
 * ```
 */ function $07f7ce389e344fbc$export$dc6d7ea554bcce10() {
    return Array.from(new Array(32), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});

parcelRegister("aWuej", function(module, exports) {
$parcel$export(module.exports, "setActiveTrace", () => $a96a24791cfa4946$export$a1002be327997103);

var $50L3Y = parcelRequire("50L3Y");

var $aiVUV = parcelRequire("aiVUV");

var $iY4Dc = parcelRequire("iY4Dc");
const $a96a24791cfa4946$var$getAnalyticsClient = (()=>{
    let instance;
    return ()=>{
        if (!instance) {
            const env = (0, $aiVUV.getEnvironment)();
            instance = new (0, $50L3Y.default)({
                env: env,
                product: 'observability'
            });
        }
        return instance;
    };
})();
function $a96a24791cfa4946$export$a1002be327997103(traceId, spanId, source) {
    // If trace context has already been set, there has been an experience collision
    // Don't update the trace context.
    if ((0, $iY4Dc.state).context !== null) $a96a24791cfa4946$var$getAnalyticsClient().sendOperationalEvent({
        source: source,
        action: 'setActiveTrace',
        actionSubject: 'traceContext',
        attributes: {
            currentContext: (0, $iY4Dc.state).context,
            incomingContext: {
                traceId: traceId,
                spanId: spanId
            },
            status: 'collision'
        },
        tags: [
            'observability'
        ]
    });
    else (0, $iY4Dc.state).context = {
        traceId: traceId,
        spanId: spanId
    };
}

});
parcelRegister("aiVUV", function(module, exports) {
$parcel$export(module.exports, "getEnvironment", () => $ff76bd5878b1b1c1$export$57570b1603cf6adb);

var $bl0Ul = parcelRequire("bl0Ul");
function $ff76bd5878b1b1c1$export$57570b1603cf6adb() {
    // Gaurd for running in the browser - if SSR (somehow) just return prod
    if (typeof window === 'undefined') return (0, $bl0Ul.envType).PROD;
    const { hostname: hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') return (0, $bl0Ul.envType).LOCAL;
    if (hostname.includes('.dev.')) return (0, $bl0Ul.envType).STAGING;
    if (hostname.includes('.stg.')) return (0, $bl0Ul.envType).STAGING;
    return (0, $bl0Ul.envType).PROD;
}

});


parcelRegister("6judq", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $e29919194223fad7$export$13e680397ec8f3eb);
class $e29919194223fad7$var$VisibilityChangeObserver {
    start() {
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $e29919194223fad7$export$13e680397ec8f3eb = new $e29919194223fad7$var$VisibilityChangeObserver();

});

parcelRegister("fNKSo", function(module, exports) {
$parcel$export(module.exports, "UntilExperience", () => $b817499c34db7249$export$3fcc0936ee2cc852);
class $b817499c34db7249$export$3fcc0936ee2cc852 {
    static{
        this.FMP = 'fmp';
    }
    static fromConfig(config) {
        return new $b817499c34db7249$export$3fcc0936ee2cc852(config.experience, config.useFmpAsUntilStopTime);
    }
    static fromMetric(metric) {
        return new $b817499c34db7249$export$3fcc0936ee2cc852(metric);
    }
    constructor(experience, useFmpAsUntilStopTime){
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
    /**
	 * If FMP mark is present, return that
	 * otherwise return the eventual load
	 */ getFmp() {
        const { marks: marks, stop: stop } = this.experience.getData();
        return marks[$b817499c34db7249$export$3fcc0936ee2cc852.FMP] ?? stop;
    }
    getDependencyStopTime() {
        if (this.useFmpAsUntilStopTime) return this.getFmp();
        return this.experience.getData().stop;
    }
    /**
	 * Get the time it takes for a segment to become fully interactable,
	 * regardless of whether it uses the FMP as the stop time. (Eventual load)
	 */ getFullyInteractiveStopTime() {
        return this.experience.getData().stop;
    }
    getIsSegmentLoadOverrided() {
        if (this.useFmpAsUntilStopTime) {
            const { marks: marks } = this.experience.getData();
            return marks[$b817499c34db7249$export$3fcc0936ee2cc852.FMP] ? true : false;
        }
        return false;
    }
    getKey() {
        return this.experience.getData().key;
    }
}

});


parcelRegister("97FbR", function(module, exports) {
$parcel$export(module.exports, "BasePageLoadMetric", () => $ce17527470f6729b$export$fd1447b187f590fe);

var $fKyz0 = parcelRequire("fKyz0");

var $5xYV9 = parcelRequire("5xYV9");
class $ce17527470f6729b$export$fd1447b187f590fe extends (0, $5xYV9.BaseMetric) {
    static{
        this.FMP = 'fmp';
    }
    constructor(args){
        super(args), this.isInitial = true, this.explicitTimings = null;
        this.config = args;
    }
    start({} = {}) {
        // please use startPageLoad
        return;
    }
    startPageLoad(params = {
        isInitial: false
    }) {
        // todo this should update meta page load metric
        this.isInitial = params.isInitial;
        if (params.isInitial) super.start({
            startTime: 0
        });
        else super.start(params);
        (0, $fKyz0.logger).logCond(!!this.config.debug, this.key, this.startTime);
    }
    stopPageLoad(pageLoadMetaMetricData, stopArguments = {
        stopTime: window.performance.now()
    }) {
        if (pageLoadMetaMetricData.state !== (0, $5xYV9.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
            (0, $fKyz0.logger).log(`meta metric has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
            (0, $fKyz0.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${pageLoadMetaMetricData.start}; stopTime: ${stopArguments.stopTime}`);
            return false;
        }
        this.merge(pageLoadMetaMetricData);
        this.stopTime = stopArguments.stopTime;
        this.state = (0, $5xYV9.MetricState).FINISHED;
        this.handleStop(stopArguments);
        return true;
    }
    handleStop(stopArguments) {
        const { until: until } = this.config;
        const fmpWasMarked = $ce17527470f6729b$export$fd1447b187f590fe.FMP in this.marks;
        if (!fmpWasMarked && until) {
            // Extract the maximum FMP value from the until metrics
            const untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                until
            ]);
            const untilFmpMarks = untilArr.map((metric)=>metric.getFmp());
            if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max(...untilFmpMarks));
        }
        super.handleStop(stopArguments);
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $ce17527470f6729b$export$fd1447b187f590fe.FMP) return;
        super.mark(mark, timestamp);
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
        this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? {
            ...mergeData.explicitTimings,
            ...this.explicitTimings
        } : null;
    }
    markFMP(timestamp) {
        super.mark($ce17527470f6729b$export$fd1447b187f590fe.FMP, timestamp);
    }
    getPageLoadData() {
        return {
            isInitial: this.isInitial,
            explicitTimings: this.explicitTimings
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageLoadData()
        };
    }
    clear() {
        this.explicitTimings = null;
        super.clear();
    }
}

});



parcelRegister("MjVw6", function(module, exports) {
$parcel$export(module.exports, "webVitalsMetrics", () => $e9e8dcf1270c5d55$export$3731db279f590f30);

var $5xYV9 = parcelRequire("5xYV9");

var $6judq = parcelRequire("6judq");

var $fCWSX = parcelRequire("fCWSX");

var $gbBjk = parcelRequire("gbBjk");
const $e9e8dcf1270c5d55$export$3731db279f590f30 = async (config, data, globalConfig)=>{
    let pageVisibleState = data.pageVisibleState;
    const setPageVisibleStateToMixed = ()=>{
        pageVisibleState = (0, $5xYV9.PageVisibleState).MIXED;
    };
    (0, $6judq.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
    const ttciEnabled = globalConfig.webVitals?.ttciEnabled !== undefined ? globalConfig.webVitals?.ttciEnabled : true;
    const webVitalMetrics = await (0, $gbBjk.webVitalsMetricCustomTimeout)(ttciEnabled, globalConfig.webVitals?.timeout || 30000);
    (0, $6judq.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
    return {
        ...webVitalMetrics,
        'pageVisible:state': pageVisibleState,
        ...(0, $fCWSX.pageVisibleValue)(config, data, globalConfig)
    };
};

});
parcelRegister("fCWSX", function(module, exports) {
$parcel$export(module.exports, "pageVisibleValue", () => $cbbc3fd8c3f5ba07$export$177b923114656380);

var $5xYV9 = parcelRequire("5xYV9");

var $3eqwL = parcelRequire("3eqwL");
const $cbbc3fd8c3f5ba07$export$177b923114656380 = (_config, data, globalConfig)=>{
    const value = globalConfig.pageVisibleValueOrigin === (0, $3eqwL.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $5xYV9.PageVisibleState).VISIBLE;
    return {
        'pageVisible:value': value
    };
};

});

parcelRegister("gbBjk", function(module, exports) {
$parcel$export(module.exports, "webVitalsMetricCustomTimeout", () => $5e1952be0bfae785$export$193ae490b52081dd);

var $9o2p1 = parcelRequire("9o2p1");
const $5e1952be0bfae785$export$193ae490b52081dd = async (ttciEnabled, timeout)=>{
    // wait for webVitalsObserver.ttciDetermined if ttciEnabled is true
    await (ttciEnabled ? (0, $9o2p1.webVitalsObserver).ttciDetermined : Promise.resolve());
    // wait up to $timeout ms longer for web-vitals until returning
    const timeoutWindow = new Promise((resolve)=>setTimeout(resolve, timeout));
    await Promise.race([
        timeoutWindow,
        (0, $9o2p1.webVitalsObserver).webVitalsDetermined
    ]);
    return (0, $9o2p1.webVitalsObserver).data;
};

});
parcelRegister("9o2p1", function(module, exports) {
$parcel$export(module.exports, "webVitalsObserver", () => $e0e67ef214570945$export$253d38dccbb37615);


class $e0e67ef214570945$var$WebVitalsObserver {
    start() {
        this.ttciDetermined = this.registerTTCI();
        this.webVitalsDetermined = this.registerWebVitals();
    }
    async registerWebVitals() {
        try {
            const { getCLS: getCLS, getFCP: getFCP, getFID: getFID, getLCP: getLCP, getTTFB: getTTFB } = await (parcelRequire("cq6Go"));
            await Promise.all([
                getTTFB,
                getFID,
                getFCP,
                getLCP,
                getCLS
            ].map((fx)=>new Promise((resolve)=>{
                    fx(({ name: name, value: value })=>{
                        // round FCP, FID, LCP, TTFB to nearest integer.
                        // CLS is rounded to two decimal places.
                        const metricName = name.toLowerCase();
                        const metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                        this.data[`metric:${metricName}`] = metricValue;
                        resolve();
                    });
                })));
        } catch (e) {}
    }
    async registerTTCI() {
        try {
            const ttiPolyfill = await (parcelRequire("l1AJ7"));
            await ttiPolyfill.getFirstConsistentlyInteractive().then((value)=>{
                // according to the docs:
                // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                // the promise resolves to null.
                this.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                return true;
            });
        } catch (e) {}
    }
    constructor(){
        this.data = {
            'metric:ttci': null,
            'metric:ttfb': null,
            'metric:fid': null,
            'metric:fcp': null,
            'metric:lcp': null,
            'metric:cls': null
        };
    }
}
const $e0e67ef214570945$export$253d38dccbb37615 = new $e0e67ef214570945$var$WebVitalsObserver();

});
parcelRegister("cq6Go", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("lG9wK").then(()=>parcelRequire('Mwsg0'));

});
parcelRegister("dk4lR", function(module, exports) {
"use strict";

function $9b3084c5dabc3940$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("8b7E8")).resolve(id));
}
module.exports = $9b3084c5dabc3940$var$load;

});
parcelRegister("8b7E8", function(module, exports) {
$parcel$export(module.exports, "register", () => $01896021d7502578$export$6503ec6e8aabbaf, (v) => $01896021d7502578$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $01896021d7502578$export$f7ad0328861e2f03, (v) => $01896021d7502578$export$f7ad0328861e2f03 = v);
var $01896021d7502578$export$6503ec6e8aabbaf;
var $01896021d7502578$export$f7ad0328861e2f03;
"use strict";
var $01896021d7502578$var$mapping = new Map();
function $01896021d7502578$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$01896021d7502578$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $01896021d7502578$var$resolve(id) {
    var resolved = $01896021d7502578$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$01896021d7502578$export$6503ec6e8aabbaf = $01896021d7502578$var$register;
$01896021d7502578$export$f7ad0328861e2f03 = $01896021d7502578$var$resolve;

});



parcelRegister("l1AJ7", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("bowC9").then(()=>parcelRequire('552Wa'));

});




parcelRegister("llUza", function(module, exports) {
$parcel$export(module.exports, "pageVisibleState", () => $bf458cd2c70df189$export$723b4c298aca63af);
const $bf458cd2c70df189$export$723b4c298aca63af = (_config, data)=>{
    return {
        'pageVisible:state': data.pageVisibleState
    };
};

});

parcelRegister("bKxXc", function(module, exports) {
$parcel$export(module.exports, "productCustomData", () => $eff0ac3143e58f63$export$fa2af6e412815a74);
const $eff0ac3143e58f63$export$fa2af6e412815a74 = async (_config, data, globalConfig)=>{
    if (!globalConfig.custom && !globalConfig.plugins) return null;
    const result = {};
    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(([key, value])=>{
        result[`${globalConfig.product}:${key}`] = value;
    });
    if (globalConfig.plugins) {
        const pluginOutputs = await Promise.all(globalConfig.plugins.map((plugin)=>plugin({
                start: data.start,
                stop: data.stop,
                key: data.key
            })));
        pluginOutputs.forEach((pluginOutput)=>{
            if (pluginOutput === null) return;
            Object.entries(pluginOutput).forEach(([key, value])=>{
                result[`${globalConfig.product}:${key}`] = value;
            });
        });
    }
    return result;
};

});

parcelRegister("149yy", function(module, exports) {
$parcel$export(module.exports, "ssrFeatureFlags", () => $2104159a57cc2eaa$export$fdbea518c19dfa8);

var $3eqwL = parcelRequire("3eqwL");
const $2104159a57cc2eaa$var$retrieveFeatureFlags = async (getFeatureFlags)=>{
    try {
        const featureFlags = await getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};
const $2104159a57cc2eaa$export$fdbea518c19dfa8 = async (config, _data, globalConfig)=>{
    // no config or missing
    if (!globalConfig.ssr?.getFeatureFlags) return null;
    const includeFeatureFlags = config.ssr?.includeFeatureFlags || globalConfig.ssr?.includeFeatureFlags || (0, $3eqwL.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
    if (includeFeatureFlags === (0, $3eqwL.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || config.ssr?.doneAsFmp && includeFeatureFlags === (0, $3eqwL.IncludeSSRFeatureFlagsConfig).WHEN_FMP) return await $2104159a57cc2eaa$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
    return null;
};

});

parcelRegister("lTqI0", function(module, exports) {
$parcel$export(module.exports, "ssrSuccess", () => $e7537fdfa9a90924$export$a3dc8251cf55b2e0);
const $e7537fdfa9a90924$export$a3dc8251cf55b2e0 = (config, _data, globalConfig)=>{
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("jm7cK", function(module, exports) {
$parcel$export(module.exports, "telemetryBrowser", () => $bb499085f840b4ae$export$386b10ac64a50b1);

var $93P8Y = parcelRequire("93P8Y");
const $bb499085f840b4ae$export$386b10ac64a50b1 = ()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($93P8Y))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($93P8Y))).getParser(window.navigator.userAgent);
    return {
        'telemetry:browser:name': browser.getBrowserName(),
        'telemetry:browser:version': browser.getBrowserVersion()
    };
};

});

parcelRegister("1g4QV", function(module, exports) {
$parcel$export(module.exports, "telemetryCpu", () => $502798e418f47c0c$export$9f84cb359ed29139);
const $502798e418f47c0c$export$9f84cb359ed29139 = ()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'telemetry:cpus': navigator.hardwareConcurrency
    };
};

});

parcelRegister("kAA8W", function(module, exports) {
$parcel$export(module.exports, "telemetryMemory", () => $122d940900c61ff7$export$496c14d72b257e07);
const $122d940900c61ff7$export$496c14d72b257e07 = ()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'telemetry:memory': navigator.deviceMemory
    };
};

});

parcelRegister("kCvPo", function(module, exports) {
$parcel$export(module.exports, "telemetryNetwork", () => $71c25747e56b267d$export$88bf7b55f7fc4e8e);
const $71c25747e56b267d$export$88bf7b55f7fc4e8e = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("dVpzR", function(module, exports) {
$parcel$export(module.exports, "appTimings", () => $bc57c946bdecb4d5$export$e952f50a4f2d02da);

var $3eqwL = parcelRequire("3eqwL");

var $02TWk = parcelRequire("02TWk");

var $bOsVM = parcelRequire("bOsVM");
const $bc57c946bdecb4d5$export$e952f50a4f2d02da = (config, data, globalConfig)=>{
    const explicitTimings = config.type === (0, $3eqwL.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    const timings = (0, $02TWk.customTimings)(config, data);
    const ssr = config.type === (0, $3eqwL.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $bOsVM.ssrTimings)(config, data, globalConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("02TWk", function(module, exports) {
$parcel$export(module.exports, "customTimings", () => $9e95a73b9a47f571$export$6126f85083a72c6e);

const $9e95a73b9a47f571$var$retrieveTimings = (config, data, relativeTo = 0, prefix = '')=>{
    const configTimings = config.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        const startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        const duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries[`${prefix}${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $9e95a73b9a47f571$export$6126f85083a72c6e = (config, data)=>{
    if (!config.timings && data.submetrics.length === 0) return null;
    const timings = $9e95a73b9a47f571$var$retrieveTimings(config, data);
    data.submetrics.forEach((submetric)=>{
        if (submetric.start !== null && submetric.stop !== null) {
            const submetricPrefix = `include:${submetric.config.key}`;
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $9e95a73b9a47f571$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $8ce4c0417f34b437$export$b98e411ae80c806f)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});
const $8ce4c0417f34b437$export$b98e411ae80c806f = '/';


parcelRegister("bOsVM", function(module, exports) {
$parcel$export(module.exports, "ssrTimings", () => $22a0fd136e9b3fa0$export$130f411261a599c5);

const $22a0fd136e9b3fa0$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $22a0fd136e9b3fa0$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $22a0fd136e9b3fa0$var$SSR_PREFIX = 'ssr';
const $22a0fd136e9b3fa0$var$mapKey = (key)=>{
    if (key === 'total') return $22a0fd136e9b3fa0$var$SSR_PREFIX;
    return `${$22a0fd136e9b3fa0$var$SSR_PREFIX}${0, $8ce4c0417f34b437$export$b98e411ae80c806f}${key}`;
};
const $22a0fd136e9b3fa0$export$130f411261a599c5 = (_config, _data, globalConfig)=>{
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    const timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($22a0fd136e9b3fa0$var$filterEntry(entry[1])) acc[$22a0fd136e9b3fa0$var$mapKey(entry[0])] = $22a0fd136e9b3fa0$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});


parcelRegister("2SPO3", function(module, exports) {
$parcel$export(module.exports, "bundleEvalTimings", () => $f240679b5f6cb63f$export$1a2bb347935fc536);
const $f240679b5f6cb63f$var$bundleEvalTimingsInternal = (_config, data, globalConfig, performance = window.performance)=>{
    const started = {};
    const timings = {};
    const enableBundleEvalTimings = globalConfig?.enableBundleEvalTimings ?? true;
    performance.getEntriesByType('mark').forEach((mark)=>{
        if (!globalConfig.bundleEvalTimings) return;
        const result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        const result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};
const $f240679b5f6cb63f$export$1a2bb347935fc536 = (...args)=>{
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve($f240679b5f6cb63f$var$bundleEvalTimingsInternal(...args));
        });
    });
};

});

parcelRegister("9b2ni", function(module, exports) {
$parcel$export(module.exports, "resourceTimings", () => $00ef8ff4b4debaf3$export$81a7d52441a06b50);
const $00ef8ff4b4debaf3$var$cacheableTypes = [
    'script',
    'link'
];
const $00ef8ff4b4debaf3$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $00ef8ff4b4debaf3$var$CACHE_NETWORK = 'network';
const $00ef8ff4b4debaf3$var$CACHE_MEMORY = 'memory';
const $00ef8ff4b4debaf3$var$CACHE_DISK = 'disk';
const $00ef8ff4b4debaf3$var$calculateTransferType = (type, duration, size)=>{
    if (!$00ef8ff4b4debaf3$var$cacheableTypes.includes(type)) return $00ef8ff4b4debaf3$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $00ef8ff4b4debaf3$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $00ef8ff4b4debaf3$var$CACHE_DISK;
    if (size === undefined) return null;
    return $00ef8ff4b4debaf3$var$CACHE_NETWORK;
};
const $00ef8ff4b4debaf3$var$hasAccessToResourceSize = (url, type, hasTimingHeaders)=>{
    return !$00ef8ff4b4debaf3$var$cacheableTypes.includes(type) || url.includes('localhost') || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
const $00ef8ff4b4debaf3$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $00ef8ff4b4debaf3$var$withoutHeaders = ()=>false;
const $00ef8ff4b4debaf3$var$evaluateAccessToResourceTimings = (entry)=>{
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
const $00ef8ff4b4debaf3$var$getEvaluatedTimingHeader = (entry, enabled = false, hasTimingHeaders = $00ef8ff4b4debaf3$var$withoutHeaders)=>{
    if (!enabled) return null;
    const manualResolution = entry.name.includes('localhost') || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    const autoResolution = $00ef8ff4b4debaf3$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
const $00ef8ff4b4debaf3$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $00ef8ff4b4debaf3$var$getNetworkData = (item, eventStart, hasTimingHeaders = $00ef8ff4b4debaf3$var$withoutHeaders)=>{
    const { name: name, duration: duration, transferSize: size, initiatorType: type, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$00ef8ff4b4debaf3$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($00ef8ff4b4debaf3$var$cacheableTypes.includes(type)) {
        const transferType = $00ef8ff4b4debaf3$var$calculateTransferType(type, duration, size);
        if (!transferType) return {
            ttfb: ttfb,
            ...$00ef8ff4b4debaf3$var$getSizeObject(size)
        };
        if (transferType !== $00ef8ff4b4debaf3$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$00ef8ff4b4debaf3$var$getSizeObject(size)
        };
    }
    return {
        ttfb: ttfb,
        ...$00ef8ff4b4debaf3$var$getSizeObject(size)
    };
};
const $00ef8ff4b4debaf3$export$81a7d52441a06b50 = (_config, data, globalConfig, performance = window.performance)=>{
    if (data.start === null) return null;
    const resources = performance.getEntriesByType('resource').filter((entry)=>entry.startTime >= data.start);
    if (!resources.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = globalConfig.resourceTimings;
    const reportedInitiatorTypes = $00ef8ff4b4debaf3$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: type } = item;
        if (!name) return;
        if (type === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $00ef8ff4b4debaf3$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type,
            ...$00ef8ff4b4debaf3$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders),
            ...$00ef8ff4b4debaf3$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});

parcelRegister("fj1Fd", function(module, exports) {
$parcel$export(module.exports, "traceContext", () => $0bae7fd17f3731de$export$90f20fc1d8cfb95b);
const $0bae7fd17f3731de$export$90f20fc1d8cfb95b = (_config, data, _globalConfig)=>{
    if (!data.traceContext) return null;
    return {
        tracingContext: {
            'X-B3-TraceId': data.traceContext.traceId,
            'X-B3-SpanId': data.traceContext.spanId
        }
    };
};

});


parcelRegister("gvHxb", function(module, exports) {
$parcel$export(module.exports, "makeShareableGlobalConfig", () => $60aa3939b0b4770b$export$5b4fb14409a2a825);

var $3eqwL = parcelRequire("3eqwL");
const $60aa3939b0b4770b$var$makeFeatureFlags = (allFeatureFlags, eventTypeFeatureFlags)=>{
    const featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push(...allFeatureFlags);
    if (eventTypeFeatureFlags) featureFlagsForType.push(...eventTypeFeatureFlags);
    return featureFlagsForType;
};
const $60aa3939b0b4770b$var$makeGlobalConfigPerType = (global, ffClient, allEventsConfig, eventConfig)=>{
    const allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    const eventConfigCustom = eventConfig && eventConfig.custom;
    const custom = (allEventsConfigCustom || eventConfigCustom) && {
        ...allEventsConfigCustom,
        ...eventConfigCustom
    } || undefined;
    const allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    const eventConfigPlugins = eventConfig && eventConfig.plugins;
    const plugins = (allEventsConfigPlugins || eventConfigPlugins) && [
        ...allEventsConfigPlugins || [],
        ...eventConfigPlugins || []
    ] || undefined;
    const pageVisibleValueOrigin = eventConfig?.pageVisibleValueOrigin ?? allEventsConfig?.pageVisibleValueOrigin ?? (0, $3eqwL.PageVisibleValueOrigin).documentHidden;
    return Object.freeze({
        ...global,
        featureFlags: Object.freeze($60aa3939b0b4770b$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce((acc, value)=>{
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig?.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig?.enableBundleEvalTimings
    });
};
const $60aa3939b0b4770b$export$5b4fb14409a2a825 = async (globalConfig)=>{
    const ffClient = await globalConfig.plugins.featureFlags.client;
    const global = {
        app: globalConfig.info.app,
        product: globalConfig.info.product,
        region: globalConfig.info.region,
        resourceTimings: globalConfig.plugins.resourceTimings,
        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
        ffClient: ffClient,
        hostname: globalConfig.info.hostname || window.location.hostname,
        ssr: globalConfig.ssr,
        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
        webVitals: {
            enabled: globalConfig.events[(0, $3eqwL.BMEventsType).WEB_VITALS]?.enabled,
            timeout: globalConfig.events[(0, $3eqwL.BMEventsType).WEB_VITALS]?.timeout,
            ttciEnabled: globalConfig.events[(0, $3eqwL.BMEventsType).WEB_VITALS]?.ttciEnabled
        }
    };
    return {
        [(0, $3eqwL.BMEventsType).PAGE_LOAD]: $60aa3939b0b4770b$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3eqwL.BMEventsType).PAGE_LOAD]),
        [(0, $3eqwL.BMEventsType).PAGE_SEGMENT_LOAD]: $60aa3939b0b4770b$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3eqwL.BMEventsType).PAGE_SEGMENT_LOAD]),
        [(0, $3eqwL.BMEventsType).INLINE_RESULT]: $60aa3939b0b4770b$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3eqwL.BMEventsType).INLINE_RESULT]),
        [(0, $3eqwL.BMEventsType).CUSTOM]: $60aa3939b0b4770b$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3eqwL.BMEventsType).CUSTOM]),
        [(0, $3eqwL.BMEventsType).WEB_VITALS]: $60aa3939b0b4770b$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3eqwL.BMEventsType).WEB_VITALS])
    };
};

});


parcelRegister("23R3w", function(module, exports) {
$parcel$export(module.exports, "SSRGetDoneMark", () => $7626201413dac13d$export$9e87a201397ac0a9);
const $7626201413dac13d$export$9e87a201397ac0a9 = {
    getDoneMark: ()=>null,
    setGetDoneMark: (fn)=>{
        $7626201413dac13d$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};

});

parcelRegister("iTVCC", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $ae153b1e98ca56c6$export$15e172712955e18f);
const $ae153b1e98ca56c6$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});

parcelRegister("4xOWz", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $4eecad660e37d662$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $4eecad660e37d662$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $4eecad660e37d662$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $4eecad660e37d662$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $4eecad660e37d662$export$837e0f79a8056912);
var $4eecad660e37d662$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $4eecad660e37d662$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $4eecad660e37d662$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $4eecad660e37d662$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $4eecad660e37d662$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $4eecad660e37d662$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $4eecad660e37d662$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $4eecad660e37d662$export$9f2bf58999404c75 = 'fmp';
const $4eecad660e37d662$export$837e0f79a8056912 = 'inline-response';

});

parcelRegister("8Vyrj", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $8c863a0b836b20e8$export$6123a44dc2384540);

const $8c863a0b836b20e8$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < (0, $790d54a7af2f6d42$export$d8b468db8a225bc9)) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};

});
const $790d54a7af2f6d42$export$d8b468db8a225bc9 = 250;


parcelRegister("d55U0", function(module, exports) {
$parcel$export(module.exports, "ufolog", () => $07b5deb938a8064d$export$b4958caff08a0960);

var $iVORW = parcelRequire("iVORW");
const $07b5deb938a8064d$export$b4958caff08a0960 = (...args)=>{
    (0, $iVORW.ufologger).log(...args);
};

});
parcelRegister("iVORW", function(module, exports) {
$parcel$export(module.exports, "ufologger", () => $a841004fd9b02007$export$4ab84f6f04f6566d);
class $a841004fd9b02007$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($a841004fd9b02007$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($a841004fd9b02007$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $a841004fd9b02007$export$4ab84f6f04f6566d = new $a841004fd9b02007$var$UFOLogger();

});


parcelRegister("bJHRc", function(module, exports) {
$parcel$export(module.exports, "ufowarn", () => $bd549039abf26568$export$d53d07b6034c4560);

var $iVORW = parcelRequire("iVORW");
const $bd549039abf26568$export$d53d07b6034c4560 = (...args)=>{
    (0, $iVORW.ufologger).warn(...args);
};

});

parcelRegister("8TSjH", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $8457c77988988ae5$export$13e680397ec8f3eb);

var $iTVCC = parcelRequire("iTVCC");
class $8457c77988988ae5$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $iTVCC.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $8457c77988988ae5$export$13e680397ec8f3eb = new $8457c77988988ae5$var$VisibilityChangeObserver();

});

parcelRegister("8nBFK", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $0728518bcdee2727$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $0728518bcdee2727$export$cc26007c03242fff);
var $0728518bcdee2727$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $0728518bcdee2727$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("c2vQm", function(module, exports) {
$parcel$export(module.exports, "CLIENT_DISPATCHER_MODULE", () => $530330725087c67b$export$eb5d9c90d65c7fea);
$parcel$export(module.exports, "getClientDispatcher", () => $530330725087c67b$export$5bb012cf9b3a5452);

var $7LhIa = parcelRequire("7LhIa");
const $530330725087c67b$export$eb5d9c90d65c7fea = 'ClientDispatcher';
let $530330725087c67b$var$dispatcher;
const $530330725087c67b$export$5bb012cf9b3a5452 = ()=>{
    if (!$530330725087c67b$var$dispatcher) {
        $530330725087c67b$var$dispatcher = new (0, $7LhIa.ClientDispatcher)();
        // Handle the server hangup scenarios
        $530330725087c67b$var$dispatcher.register($530330725087c67b$export$eb5d9c90d65c7fea, $530330725087c67b$var$dispatcher._abort.bind($530330725087c67b$var$dispatcher));
    }
    return $530330725087c67b$var$dispatcher;
};

});
parcelRegister("7LhIa", function(module, exports) {
$parcel$export(module.exports, "ClientDispatcher", () => $6c81eb42c1d8de52$export$3f5ba18eb97af725);
class $6c81eb42c1d8de52$export$3f5ba18eb97af725 {
    constructor(){
        this.handlers = new Map();
        this.abortHandlers = new Map();
        this.queuedPayloads = new Map();
    }
    /**
	 * Ingest a payload from the server.
	 * This will trigger a callback to the component that registered for this event, otherwise the payload will be queued to do so later.
	 * @param payload - The payload to ingest.
	 */ ingest(payload) {
        const handler = this.handlers.get(payload.id);
        if (handler) this.exec(handler, payload);
        else {
            const queue = this.queuedPayloads.get(payload.id) || [];
            queue.push(payload);
            this.queuedPayloads.set(payload.id, queue);
        }
    }
    /**
	 * Register a callback for a given event. If any payloads were queued for this event, they will be processed immediately.
	 * @param id - The event ID to register for.
	 * @param callback - The callback to trigger when the event is ingested.
	 */ register(id, callback) {
        this.handlers.set(id, callback);
        // Process any queued payloads for this handler
        const queuedPayloads = this.queuedPayloads.get(id) || [];
        if (queuedPayloads.length > 0) {
            queuedPayloads.forEach((payload)=>this.exec(callback, payload));
            this.queuedPayloads.delete(id);
        }
    }
    /**
	 * Unregister a callback for a given event.
	 * @param id
	 */ unregister(id) {
        this.handlers.delete(id);
        this.queuedPayloads.delete(id);
    }
    /**
	 * Register an abort handler that will get called if exceptional circmstances arise (such as SSR hanging up due to deadline exceeded)
	 * @param id - The event ID to register for.
	 * @param callback - The callback to trigger when abort detected.
	 */ onAbort(id, callback) {
        if (this.abortReason) this.exec(callback, {
            args: [
                this.abortReason
            ]
        });
        else this.abortHandlers.set(id, callback);
    }
    /**
	 * Notify any registered abort handlers that the server exceeded its deadline before finishing, so we may not have received all events.
	 * @private
	 * @param props
	 */ _abort(props) {
        this.abortReason = props;
        this.abortHandlers.forEach((handler)=>{
            this.exec(handler, {
                args: [
                    props
                ]
            });
        });
        // We can delete these now that we've handled the case and remainder will be dealt with immediately.
        this.abortHandlers = new Map();
    }
    /**
	 * Execute a callback with the given payload.
	 * @param callback - The callback to execute.
	 * @param payload - The payload to execute the callback with.
	 */ exec(callback, payload) {
        const { args: args, error: error } = payload;
        try {
            if (error) throw error;
            // @ts-expect-error
            callback(...args);
        } catch (err) {
        // TODO: log error
        // console.error(err);
        }
    }
}

});


parcelRegister("kcAhT", function(module, exports) {
$parcel$export(module.exports, "registerEvent", () => $973ebc03452f89ba$export$bd50bc4cd3c601ee);
const $973ebc03452f89ba$var$events = [];
const $973ebc03452f89ba$export$bd50bc4cd3c601ee = (event)=>{
    $973ebc03452f89ba$var$events.push(event);
};
const $973ebc03452f89ba$export$3c7145db84d4587c = ()=>{
    return $973ebc03452f89ba$var$events.splice(0, $973ebc03452f89ba$var$events.length);
};

});

parcelRegister("kAAlR", function(module, exports) {
$parcel$export(module.exports, "default", () => $44d05d97cc2c4955$export$2e2bcd8739ae039);
// The UFORouteName object is a global singleton
const $44d05d97cc2c4955$var$UFORouteName = {
    current: null
};
var $44d05d97cc2c4955$export$2e2bcd8739ae039 = $44d05d97cc2c4955$var$UFORouteName;

});

parcelRegister("6Uiqc", function(module, exports) {
$parcel$export(module.exports, "browserMetrics", () => $3988da0d1aa7c795$export$c08e7affcf78b064);

var $23R3w = parcelRequire("23R3w");

var $fKyz0 = parcelRequire("fKyz0");

var $es0Kq = parcelRequire("es0Kq");

var $6judq = parcelRequire("6judq");

var $9o2p1 = parcelRequire("9o2p1");

var $e4IhG = parcelRequire("e4IhG");

var $f3izM = parcelRequire("f3izM");

var $3eqwL = parcelRequire("3eqwL");
const $3988da0d1aa7c795$var$makeBrowserMetrics = ()=>{
    const bm = {
        init (config) {
            (0, $6judq.visibilityChangeObserver).start();
            if (config.events[(0, $3eqwL.BMEventsType).WEB_VITALS]?.enabled) (0, $9o2p1.webVitalsObserver).start();
            if (config.debug) {
                (0, $fKyz0.logger).enable();
                (0, $f3izM.submitter).setDebug(true);
                (0, $es0Kq.pageLoadMetaMetric).setDebug(true);
            }
            (0, $f3izM.submitter).configure(config);
            if (config.ssr?.getDoneMark) (0, $23R3w.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute (newRoute) {
            (0, $e4IhG.Route).setRoute(newRoute);
        },
        startPageLoad (params) {
            (0, $es0Kq.pageLoadMetaMetric).startPageLoad({
                isInitial: false,
                cancelStarted: true,
                ...params
            });
        },
        getPageLoadMetric () {
            return 0, $es0Kq.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks (name, startMark, stopMark, initialOnly = true) {
            if (initialOnly && !(0, $es0Kq.pageLoadMetaMetric).isInitialLoad()) return;
            const start = performance.getEntriesByName(startMark);
            const stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $es0Kq.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                const pageLoadData = (0, $es0Kq.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    const startMark = start[start.length - 1];
                    const timing = {
                        startTime: Math.round(startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - startMark.startTime)
                    };
                    (0, $es0Kq.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
const $3988da0d1aa7c795$export$c08e7affcf78b064 = $3988da0d1aa7c795$var$makeBrowserMetrics();

});

parcelRegister("gglhF", function(module, exports) {
$parcel$export(module.exports, "sinkTerminalErrorHandler", () => $1b42c9a8fe2a7f81$export$e5fa3ac6dc44efff);
$parcel$export(module.exports, "useReportTerminalError", () => $1b42c9a8fe2a7f81$export$79ee0f0d40355053);

var $fsvuC = parcelRequire("fsvuC");

var $aXWJz = parcelRequire("aXWJz");

var $dOQFV = parcelRequire("dOQFV");

var $8IAtM = parcelRequire("8IAtM");

var $kAAlR = parcelRequire("kAAlR");

var $eES9N = parcelRequire("eES9N");
let $1b42c9a8fe2a7f81$var$sinkHandlerFn = ()=>{};
function $1b42c9a8fe2a7f81$export$e5fa3ac6dc44efff(fn) {
    $1b42c9a8fe2a7f81$var$sinkHandlerFn = fn;
}
const $1b42c9a8fe2a7f81$var$RELAY_NETWORK_ERRORS_NAME = 'RelayNetwork';
const $1b42c9a8fe2a7f81$export$1a949ef92fd30eca = (error)=>error.name === $1b42c9a8fe2a7f81$var$RELAY_NETWORK_ERRORS_NAME;
const $1b42c9a8fe2a7f81$var$isErrorObject = (error)=>typeof error === 'object' && error !== null;
const $1b42c9a8fe2a7f81$var$getErrorStatusCode = (error)=>{
    if (!$1b42c9a8fe2a7f81$var$isErrorObject(error)) return undefined;
    if ($1b42c9a8fe2a7f81$export$1a949ef92fd30eca(error)) return error.source?.errors?.[0]?.extensions?.statusCode;
    if ('statusCode' in error && typeof error.statusCode === 'number') return error.statusCode;
    return undefined;
};
const $1b42c9a8fe2a7f81$var$getErrorTraceId = (error)=>$1b42c9a8fe2a7f81$var$isErrorObject(error) && 'traceId' in error && typeof error.traceId === 'string' ? error.traceId : undefined;
function $1b42c9a8fe2a7f81$export$3e4fb24086cfb97a(error, additionalAttributes, labelStack) {
    const activeInteraction = (0, $8IAtM.getActiveInteraction)();
    const currentTime = performance.now();
    const baseErrorData = {
        errorType: error.name || 'Error',
        errorMessage: error.message?.slice(0, 100) || 'Unknown error',
        timestamp: currentTime,
        errorCategory: (0, $eES9N.classifyTerminalError)(error)
    };
    const errorData = {
        ...baseErrorData,
        statusCode: additionalAttributes?.statusCode ?? $1b42c9a8fe2a7f81$var$getErrorStatusCode(error),
        // Fallback to traceId from error object if it exists (e.g. FetchError)
        traceId: (0, $aXWJz.getActiveTrace)()?.traceId ?? $1b42c9a8fe2a7f81$var$getErrorTraceId(error),
        teamName: additionalAttributes?.teamName,
        packageName: additionalAttributes?.packageName,
        errorBoundaryId: additionalAttributes?.errorBoundaryId,
        errorHash: additionalAttributes?.errorHash,
        fallbackType: additionalAttributes?.fallbackType
    };
    // Calculate time since previous interaction
    const timeSincePreviousInteraction = (0, $8IAtM.PreviousInteractionLog).timestamp != null ? currentTime - (0, $8IAtM.PreviousInteractionLog).timestamp : null;
    const context = {
        labelStack: labelStack ?? null,
        activeInteractionName: activeInteraction?.ufoName ?? null,
        activeInteractionId: activeInteraction?.id ?? null,
        activeInteractionType: activeInteraction?.type ?? null,
        previousInteractionId: (0, $8IAtM.PreviousInteractionLog).id ?? null,
        previousInteractionName: (0, $8IAtM.PreviousInteractionLog).name ?? null,
        previousInteractionType: (0, $8IAtM.PreviousInteractionLog).type ?? null,
        timeSincePreviousInteraction: timeSincePreviousInteraction,
        routeName: (0, $kAAlR.default).current ?? null
    };
    $1b42c9a8fe2a7f81$var$sinkHandlerFn(errorData, context);
}
function $1b42c9a8fe2a7f81$export$79ee0f0d40355053(error, additionalAttributes) {
    const interactionContext = (0, $dOQFV.useInteractionContext)();
    const hasReportedRef = (0, $fsvuC.useRef)(false);
    (0, $fsvuC.useEffect)(()=>{
        if (error && !hasReportedRef.current) {
            hasReportedRef.current = true;
            $1b42c9a8fe2a7f81$export$3e4fb24086cfb97a(error, additionalAttributes, interactionContext?.labelStack);
        }
    }, [
        error,
        additionalAttributes,
        interactionContext?.labelStack
    ]);
}

});
parcelRegister("eES9N", function(module, exports) {
$parcel$export(module.exports, "classifyTerminalError", () => $1fdff1ea24ee6542$export$17e837b2daecf805);
const $1fdff1ea24ee6542$var$ABORT_ERROR_NAMES = new Set([
    'AbortError'
]);
const $1fdff1ea24ee6542$var$ABORT_ERROR_MESSAGES = [
    'The operation was aborted',
    'auth_window_closed'
];
// Only treated as abort when combined with AuthError name — the same string
// can appear in other error messages (e.g. 403 response bodies) where it
// should not be classified as abort.
const $1fdff1ea24ee6542$var$AUTH_ERROR_ABORT_MESSAGES = [
    'access_denied'
];
// AuthError is thrown by @atlaskit/outbound-auth-flow-client during OAuth flows
// (e.g. connecting third-party apps like GitHub or Bitbucket to Jira).
// User-initiated outcomes (closing the popup, denying consent) are classified
// as abort; server/config failures are classified as auth.
const $1fdff1ea24ee6542$var$AUTH_ERROR_NAMES = new Set([
    'AuthError'
]);
const $1fdff1ea24ee6542$var$CHUNK_LOAD_ERROR_NAMES = new Set([
    'ChunkLoadError'
]);
const $1fdff1ea24ee6542$var$CHUNK_LOAD_ERROR_MESSAGES = [
    'Unable to fetch manifest',
    'dynamically imported module',
    'Importing a module script failed'
];
const $1fdff1ea24ee6542$var$NETWORK_CLIENT_ERROR_NAMES = new Set([
    'NetworkError',
    'Network error'
]);
const $1fdff1ea24ee6542$var$NETWORK_CLIENT_ERROR_MESSAGES = [
    'Failed to fetch',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'server with the specified hostname could not be found',
    'The network connection was lost',
    'The request timed out',
    'connection failure',
    'CloseEvent: Ping timeout',
    'Curl Error: Failure when receiving data from the peer'
];
const $1fdff1ea24ee6542$var$NETWORK_SERVER_ERROR_MESSAGES = [
    '... is not valid JSON',
    'in JSON at position 0',
    'JSON.parse: unexpected character',
    'JSON.parse: unexpected end of data',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'cannot parse response',
    'Syntax or http error'
];
function $1fdff1ea24ee6542$var$matchesCategory(error) {
    const name = error.name ?? '';
    const message = error.message ?? '';
    if ($1fdff1ea24ee6542$var$ABORT_ERROR_NAMES.has(name) || $1fdff1ea24ee6542$var$ABORT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern)) || // OAuth Abort errors
    $1fdff1ea24ee6542$var$AUTH_ERROR_NAMES.has(name) && $1fdff1ea24ee6542$var$AUTH_ERROR_ABORT_MESSAGES.some((pattern)=>message.includes(pattern))) return 'abort';
    if ($1fdff1ea24ee6542$var$AUTH_ERROR_NAMES.has(name)) return 'auth';
    if ($1fdff1ea24ee6542$var$CHUNK_LOAD_ERROR_NAMES.has(name) || $1fdff1ea24ee6542$var$CHUNK_LOAD_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'chunk-load';
    if ($1fdff1ea24ee6542$var$NETWORK_CLIENT_ERROR_NAMES.has(name) || $1fdff1ea24ee6542$var$NETWORK_CLIENT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-client';
    if ($1fdff1ea24ee6542$var$NETWORK_SERVER_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-server';
    return null;
}
function $1fdff1ea24ee6542$export$17e837b2daecf805(error) {
    const directMatch = $1fdff1ea24ee6542$var$matchesCategory(error);
    if (directMatch) return directMatch;
    if (typeof error === 'object' && error !== null && 'cause' in error && error.cause instanceof Error) {
        const cause = error.cause;
        const causeMatch = $1fdff1ea24ee6542$var$matchesCategory(cause);
        if (causeMatch) return causeMatch;
    }
    return 'product';
}

});


parcelRegister("6w4dH", function(module, exports) {
$parcel$export(module.exports, "deleteCookie", () => $43c7b3e9d071702d$export$b43e45590305ffaa);

var $k3O8N = parcelRequire("k3O8N");

var $llCao = parcelRequire("llCao");

var $52k2b = parcelRequire("52k2b");

var $2yNBb = parcelRequire("2yNBb");
const $43c7b3e9d071702d$export$b43e45590305ffaa = (key, attributes)=>{
    if ((0, $llCao.fg)('platform_moonjelly_bsc_master_killswitch')) // Delete the cookie without package operational events
    // when master killswitch is enabled
    (0, $k3O8N.default).remove(key, attributes);
    else try {
        (0, $52k2b.sendPackageOperationalEvent)({
            action: 'usedDeleteCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, $k3O8N.default).remove(key, attributes);
    } catch (e) {
        (0, $2yNBb.Logger).errorWithOperationalEvent({
            action: 'usedDeleteCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use delete cookie. ${e.message || ''}`
        });
        throw e;
    }
};

});
parcelRegister("52k2b", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsClient", () => $3ad07c7d2d6878a9$export$fde53e78fd93a54d);
$parcel$export(module.exports, "sendPackageOperationalEvent", () => $3ad07c7d2d6878a9$export$5bfe55348e7aebc1);
$parcel$export(module.exports, "sendUnsampledPackageOperationalEvent", () => $3ad07c7d2d6878a9$export$c986f0e7f985d67f);
$parcel$export(module.exports, "sendUIEvent", () => $3ad07c7d2d6878a9$export$1aecf263098db667);
$parcel$export(module.exports, "sendScreenEvent", () => $3ad07c7d2d6878a9$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendTrackEvent", () => $3ad07c7d2d6878a9$export$1ba525b8a711eaac);

var $bl0Ul = parcelRequire("bl0Ul");

var $50L3Y = parcelRequire("50L3Y");

var $llCao = parcelRequire("llCao");

var $4kM1J = parcelRequire("4kM1J");


var $6PIqM = parcelRequire("6PIqM");

var $2FGbl = parcelRequire("2FGbl");

var $g5xfM = parcelRequire("g5xfM");
const $3ad07c7d2d6878a9$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.') || hostname.includes('.jira-dev.') || hostname.includes('.jira-stg.')) return (0, $bl0Ul.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $bl0Ul.envType).DEV;
    return (0, $bl0Ul.envType).PROD;
};
const $3ad07c7d2d6878a9$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $3ad07c7d2d6878a9$var$getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const $3ad07c7d2d6878a9$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $3ad07c7d2d6878a9$export$78d7c0236b4fece9(pathname);
    const domain = `${origin}${productPath}`;
    const product = $3ad07c7d2d6878a9$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const $3ad07c7d2d6878a9$var$decorateEventAttributes = (attributes)=>{
    const { domain: domain, product: product } = $3ad07c7d2d6878a9$export$fce3dd735e04d566();
    return {
        packageName: (0, $llCao.fg)('platform_bsc_use_generated_package_info') ? (0, $2FGbl.packageName) : (0, $6PIqM.packageName),
        packageVersion: (0, $llCao.fg)('platform_bsc_use_generated_package_info') ? (0, $2FGbl.packageVersion) : (0, $6PIqM.packageVersion),
        domain: domain,
        product: (0, $4kM1J.getBscGlobalState)().product?.toLowerCase() ?? product,
        ...attributes && attributes
    };
};
const $3ad07c7d2d6878a9$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $4kM1J.getBscGlobalState)().analyticsEnabled) {
                instance = new (0, $50L3Y.default)({
                    env: $3ad07c7d2d6878a9$var$getEnvironment(),
                    product: 'atlassianCookies'
                }, {
                    // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                    // When set to false, the client will use a stargate proxy for the current URL to send events
                    // to GAS. Said another way:
                    // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                    // false => events are sent to <the current domain>/gasv3/api/v1/batch
                    //
                    // By default, this should be set to false.  If you need to validate that analytics events
                    // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                    // won't be able to proxy to GAS via stargate.
                    useLegacyUrl: false,
                    disableCookiePersistence: true
                });
                if ((0, $4kM1J.getBscGlobalState)().cloudId) instance.setTenantInfo((0, $bl0Ul.tenantType).CLOUD_ID, (0, $4kM1J.getBscGlobalState)().cloudId);
                if ((0, $4kM1J.getBscGlobalState)().userId) instance.setUserInfo((0, $bl0Ul.userType).ATLASSIAN_ACCOUNT, (0, $4kM1J.getBscGlobalState)().userId ?? '');
            }
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            // eslint-disable-next-line no-console
            console.error(`${(0, $9f5054f87e3e2d3a$export$5e28bf885ebebfa6)}: Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $4kM1J.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $3ad07c7d2d6878a9$export$5bfe55348e7aebc1(properties) {
    (0, $g5xfM.withAnalyticsEventSampling)(properties.action, ()=>$3ad07c7d2d6878a9$export$fde53e78fd93a54d()?.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $3ad07c7d2d6878a9$var$decorateEventAttributes(properties.attributes)
        }));
}
function $3ad07c7d2d6878a9$export$c986f0e7f985d67f(properties) {
    $3ad07c7d2d6878a9$export$fde53e78fd93a54d()?.sendOperationalEvent({
        source: 'package',
        actionSubject: 'package',
        action: properties.action,
        attributes: $3ad07c7d2d6878a9$var$decorateEventAttributes(properties.attributes)
    });
}
function $3ad07c7d2d6878a9$export$1aecf263098db667(properties) {
    (0, $g5xfM.withAnalyticsEventSampling)(properties.actionSubjectId, ()=>$3ad07c7d2d6878a9$export$fde53e78fd93a54d()?.sendUIEvent({
            ...properties,
            attributes: $3ad07c7d2d6878a9$var$decorateEventAttributes(properties.attributes)
        }));
}
function $3ad07c7d2d6878a9$export$22a3b1671f38a193(properties) {
    (0, $g5xfM.withAnalyticsEventSampling)(properties.name, ()=>$3ad07c7d2d6878a9$export$fde53e78fd93a54d()?.sendScreenEvent({
            ...properties,
            attributes: $3ad07c7d2d6878a9$var$decorateEventAttributes(properties.attributes)
        }));
}
function $3ad07c7d2d6878a9$export$1ba525b8a711eaac(properties) {
    const { onSent: onSent, ...eventProperties } = properties;
    (0, $g5xfM.withAnalyticsEventSampling)(properties.actionSubject, ()=>{
        const client = $3ad07c7d2d6878a9$export$fde53e78fd93a54d();
        if (!client) // No client means nothing was emitted, so we must not run onSent
        return;
        client.sendTrackEvent({
            ...eventProperties,
            attributes: $3ad07c7d2d6878a9$var$decorateEventAttributes(properties.attributes)
        });
        onSent?.();
    });
}

});
parcelRegister("4kM1J", function(module, exports) {
$parcel$export(module.exports, "getBscGlobalState", () => $8f618495e45e290c$export$3b78a1ea01f5ec28);
$parcel$export(module.exports, "__internalApplyInitialState", () => $8f618495e45e290c$export$725ef39b428c0dc2);
$parcel$export(module.exports, "__internalGetPatternFormat", () => $8f618495e45e290c$export$f9550288b9b1f6e3);
$parcel$export(module.exports, "__internalSetPatternFormat", () => $8f618495e45e290c$export$f10a7691f1fb3cb);
$parcel$export(module.exports, "__internalGetResolvedFlatPatternFileFormat", () => $8f618495e45e290c$export$8bf1367cc4bb66da);
$parcel$export(module.exports, "__internalSetResolvedFlatPatternFileFormat", () => $8f618495e45e290c$export$2bd306fd2b97e710);
$parcel$export(module.exports, "__internalGetHasInitialized", () => $8f618495e45e290c$export$8835d45f445e6ba4);
$parcel$export(module.exports, "__internalGetProductGlobalState", () => $8f618495e45e290c$export$9dfdd17bbd03b460);
$parcel$export(module.exports, "__internalGetWebStorageControlsEnabledGlobalState", () => $8f618495e45e290c$export$d96c3b0fb6d35c5d);
$parcel$export(module.exports, "__internalGetIndexedDbControlsEnabledGlobalState", () => $8f618495e45e290c$export$c8554d68c78456d3);
$parcel$export(module.exports, "__internalGetDisableWebStorageConsentChecksGlobalState", () => $8f618495e45e290c$export$ea650e4f51ec84d8);
$parcel$export(module.exports, "__internalGetAllowUncategorizedCookiesInOverridesGlobalState", () => $8f618495e45e290c$export$fa1f6ebb49ec4b30);
$parcel$export(module.exports, "__internalGetAllowUncategorizedItemsInWebStorageOverridesGlobalState", () => $8f618495e45e290c$export$b60c6437117dfaf9);
$parcel$export(module.exports, "__internalGetAllowUncategorizedItemsInIndexedDBOverridesGlobalState", () => $8f618495e45e290c$export$cff869f7e58c9036);
$parcel$export(module.exports, "__internalSetCacheLoadedDate", () => $8f618495e45e290c$export$491d0e6c401a0697);
$parcel$export(module.exports, "__internalGetDisableIndexedDbConsentChecksGlobalState", () => $8f618495e45e290c$export$ea32fe1e8610fd3b);

var $hw3pG = parcelRequire("hw3pG");

var $i3sVo = parcelRequire("i3sVo");
let $8f618495e45e290c$var$analyticsEnabledGlobalState;
let $8f618495e45e290c$var$productGlobalState;
let $8f618495e45e290c$var$perimeterGlobalState;
let $8f618495e45e290c$var$webStorageControlsEnabledGlobalState;
let $8f618495e45e290c$var$indexedDbControlsEnabledGlobalState;
let $8f618495e45e290c$var$disableWebStorageConsentChecksGlobalState;
let $8f618495e45e290c$var$localConsentModeGlobalState;
let $8f618495e45e290c$var$packageLogLevelGlobalState;
let $8f618495e45e290c$var$allowUncategorizedCookiesInOverridesGlobalState;
let $8f618495e45e290c$var$allowUncategorizedItemsInWebStorageOverridesGlobalState;
let $8f618495e45e290c$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState;
let $8f618495e45e290c$var$disableIndexedDbConsentChecksGlobalState;
let $8f618495e45e290c$var$userIdGlobalState;
let $8f618495e45e290c$var$cloudIdGlobalState;
let $8f618495e45e290c$var$hasInitialized = false;
let $8f618495e45e290c$var$cacheLoadedDateGlobalState;
let $8f618495e45e290c$var$patternFormatGlobalState;
let $8f618495e45e290c$var$resolvedFlatPatternFileFormatGlobalState;
let $8f618495e45e290c$var$cookiesCacheLoader;
let $8f618495e45e290c$var$localStorageCacheLoader;
let $8f618495e45e290c$var$sessionStorageCacheLoader;
let $8f618495e45e290c$var$indexedDBCacheLoader;
let $8f618495e45e290c$var$loadCache = async (storageType)=>{
    switch(storageType){
        case (0, $hw3pG.CategoryStorageType).Cookies:
            return await $8f618495e45e290c$var$cookiesCacheLoader?.loadStorageControlsData();
        case (0, $hw3pG.CategoryStorageType).LocalStorage:
            return await $8f618495e45e290c$var$localStorageCacheLoader?.loadStorageControlsData();
        case (0, $hw3pG.CategoryStorageType).SessionStorage:
            return await $8f618495e45e290c$var$sessionStorageCacheLoader?.loadStorageControlsData();
        case (0, $hw3pG.CategoryStorageType).IndexedDB:
            return await $8f618495e45e290c$var$indexedDBCacheLoader?.loadStorageControlsData();
        default:
            return undefined;
    }
};
let $8f618495e45e290c$var$loadCacheMaybeSync = (storageType)=>{
    switch(storageType){
        case (0, $hw3pG.CategoryStorageType).Cookies:
            return $8f618495e45e290c$var$cookiesCacheLoader?.getStorageControlsDataFromCache() ?? $8f618495e45e290c$var$cookiesCacheLoader?.loadStorageControlsData();
        case (0, $hw3pG.CategoryStorageType).LocalStorage:
            return $8f618495e45e290c$var$localStorageCacheLoader?.getStorageControlsDataFromCache() ?? $8f618495e45e290c$var$localStorageCacheLoader?.loadStorageControlsData();
        case (0, $hw3pG.CategoryStorageType).SessionStorage:
            return $8f618495e45e290c$var$sessionStorageCacheLoader?.getStorageControlsDataFromCache() ?? $8f618495e45e290c$var$sessionStorageCacheLoader?.loadStorageControlsData();
        case (0, $hw3pG.CategoryStorageType).IndexedDB:
            return $8f618495e45e290c$var$indexedDBCacheLoader?.getStorageControlsDataFromCache() ?? $8f618495e45e290c$var$indexedDBCacheLoader?.loadStorageControlsData();
        default:
            return undefined;
    }
};
const $8f618495e45e290c$export$3b78a1ea01f5ec28 = ()=>{
    return {
        analyticsEnabled: $8f618495e45e290c$var$analyticsEnabledGlobalState ?? true,
        product: $8f618495e45e290c$var$productGlobalState,
        perimeter: $8f618495e45e290c$var$perimeterGlobalState,
        webStorageEnabled: $8f618495e45e290c$var$webStorageControlsEnabledGlobalState ?? false,
        indexedDbEnabled: $8f618495e45e290c$var$indexedDbControlsEnabledGlobalState ?? false,
        disableWebStorageConsentChecks: $8f618495e45e290c$var$disableWebStorageConsentChecksGlobalState ?? false,
        localConsentMode: $8f618495e45e290c$var$localConsentModeGlobalState ?? false,
        allowUncategorizedCookiesInOverrides: $8f618495e45e290c$var$allowUncategorizedCookiesInOverridesGlobalState ?? false,
        allowUncategorizedItemsInWebStorageOverrides: $8f618495e45e290c$var$allowUncategorizedItemsInWebStorageOverridesGlobalState ?? false,
        allowUncategorizedItemsInIndexedDBOverrides: $8f618495e45e290c$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState ?? false,
        disableIndexedDbConsentChecks: $8f618495e45e290c$var$disableIndexedDbConsentChecksGlobalState ?? false,
        packageLogLevel: $8f618495e45e290c$var$packageLogLevelGlobalState,
        cookiesCacheLoader: $8f618495e45e290c$var$cookiesCacheLoader,
        localStorageCacheLoader: $8f618495e45e290c$var$localStorageCacheLoader,
        sessionStorageCacheLoader: $8f618495e45e290c$var$sessionStorageCacheLoader,
        indexedDBCacheLoader: $8f618495e45e290c$var$indexedDBCacheLoader,
        loadCache: $8f618495e45e290c$var$loadCache,
        loadCacheMaybeSync: $8f618495e45e290c$var$loadCacheMaybeSync,
        hasInitialized: $8f618495e45e290c$var$hasInitialized,
        userId: $8f618495e45e290c$var$userIdGlobalState,
        cloudId: $8f618495e45e290c$var$cloudIdGlobalState,
        cacheLoadedDate: $8f618495e45e290c$var$cacheLoadedDateGlobalState,
        patternFormat: $8f618495e45e290c$var$patternFormatGlobalState
    };
};
const $8f618495e45e290c$export$f86e17381f699baf = ({ loadCache: overrideLoadCache, loadCacheMaybeSync: overrideLoadCacheMaybeSync, product: overrideProduct })=>{
    if (overrideLoadCache) $8f618495e45e290c$var$loadCache = overrideLoadCache;
    if (overrideLoadCacheMaybeSync) $8f618495e45e290c$var$loadCacheMaybeSync = overrideLoadCacheMaybeSync;
    if (overrideProduct) $8f618495e45e290c$var$productGlobalState = overrideProduct;
};
const $8f618495e45e290c$export$ac7c2edd09656c05 = ()=>{
    $8f618495e45e290c$var$analyticsEnabledGlobalState = undefined;
    $8f618495e45e290c$var$productGlobalState = undefined;
    $8f618495e45e290c$var$webStorageControlsEnabledGlobalState = undefined;
    $8f618495e45e290c$var$indexedDbControlsEnabledGlobalState = undefined;
    $8f618495e45e290c$var$disableWebStorageConsentChecksGlobalState = undefined;
    $8f618495e45e290c$var$localConsentModeGlobalState = undefined;
    $8f618495e45e290c$var$allowUncategorizedCookiesInOverridesGlobalState = undefined;
    $8f618495e45e290c$var$allowUncategorizedItemsInWebStorageOverridesGlobalState = undefined;
    $8f618495e45e290c$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState = undefined;
    $8f618495e45e290c$var$disableIndexedDbConsentChecksGlobalState = undefined;
    $8f618495e45e290c$var$userIdGlobalState = undefined;
    $8f618495e45e290c$var$cloudIdGlobalState = undefined;
    $8f618495e45e290c$var$packageLogLevelGlobalState = undefined;
    // Reset the resolved-log-level cache too, so a teardown that clears global state without a
    // following initializeGlobalState() can't bleed the previous request's level into the next.
    (0, $i3sVo.resetLogLevelCache)();
    $8f618495e45e290c$var$cookiesCacheLoader = undefined;
    $8f618495e45e290c$var$localStorageCacheLoader = undefined;
    $8f618495e45e290c$var$sessionStorageCacheLoader = undefined;
    $8f618495e45e290c$var$indexedDBCacheLoader = undefined;
    $8f618495e45e290c$var$hasInitialized = false;
    $8f618495e45e290c$var$cacheLoadedDateGlobalState = undefined;
    $8f618495e45e290c$var$patternFormatGlobalState = undefined;
    $8f618495e45e290c$var$resolvedFlatPatternFileFormatGlobalState = undefined;
};
function $8f618495e45e290c$export$725ef39b428c0dc2(updates) {
    if (updates.productGlobalState !== undefined) $8f618495e45e290c$var$productGlobalState = updates.productGlobalState;
    if (updates.webStorageControlsEnabledGlobalState !== undefined) $8f618495e45e290c$var$webStorageControlsEnabledGlobalState = updates.webStorageControlsEnabledGlobalState;
    if (updates.indexedDbControlsEnabledGlobalState !== undefined) $8f618495e45e290c$var$indexedDbControlsEnabledGlobalState = updates.indexedDbControlsEnabledGlobalState;
    if (updates.disableWebStorageConsentChecksGlobalState !== undefined) $8f618495e45e290c$var$disableWebStorageConsentChecksGlobalState = updates.disableWebStorageConsentChecksGlobalState;
    if (updates.allowUncategorizedCookiesInOverridesGlobalState !== undefined) $8f618495e45e290c$var$allowUncategorizedCookiesInOverridesGlobalState = updates.allowUncategorizedCookiesInOverridesGlobalState;
    if (updates.allowUncategorizedItemsInWebStorageOverridesGlobalState !== undefined) $8f618495e45e290c$var$allowUncategorizedItemsInWebStorageOverridesGlobalState = updates.allowUncategorizedItemsInWebStorageOverridesGlobalState;
    if (updates.allowUncategorizedItemsInIndexedDBOverridesGlobalState !== undefined) $8f618495e45e290c$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState = updates.allowUncategorizedItemsInIndexedDBOverridesGlobalState;
    if (updates.disableIndexedDbConsentChecksGlobalState !== undefined) $8f618495e45e290c$var$disableIndexedDbConsentChecksGlobalState = updates.disableIndexedDbConsentChecksGlobalState;
    if (updates.localConsentModeGlobalState !== undefined) $8f618495e45e290c$var$localConsentModeGlobalState = updates.localConsentModeGlobalState;
    if (updates.analyticsEnabledGlobalState !== undefined) $8f618495e45e290c$var$analyticsEnabledGlobalState = updates.analyticsEnabledGlobalState;
    if (updates.perimeterGlobalState !== undefined) $8f618495e45e290c$var$perimeterGlobalState = updates.perimeterGlobalState;
    if (updates.cookiesCacheLoader !== undefined) $8f618495e45e290c$var$cookiesCacheLoader = updates.cookiesCacheLoader;
    if (updates.localStorageCacheLoader !== undefined) $8f618495e45e290c$var$localStorageCacheLoader = updates.localStorageCacheLoader;
    if (updates.sessionStorageCacheLoader !== undefined) $8f618495e45e290c$var$sessionStorageCacheLoader = updates.sessionStorageCacheLoader;
    if (updates.indexedDBCacheLoader !== undefined) $8f618495e45e290c$var$indexedDBCacheLoader = updates.indexedDBCacheLoader;
    if (updates.packageLogLevelGlobalState !== undefined) $8f618495e45e290c$var$packageLogLevelGlobalState = updates.packageLogLevelGlobalState;
    if (updates.hasInitialized !== undefined) $8f618495e45e290c$var$hasInitialized = updates.hasInitialized;
    if (updates.cloudIdGlobalState !== undefined) $8f618495e45e290c$var$cloudIdGlobalState = updates.cloudIdGlobalState;
    if (updates.userIdGlobalState !== undefined) $8f618495e45e290c$var$userIdGlobalState = updates.userIdGlobalState;
}
function $8f618495e45e290c$export$f9550288b9b1f6e3() {
    return $8f618495e45e290c$var$patternFormatGlobalState;
}
function $8f618495e45e290c$export$f10a7691f1fb3cb(patternFormat) {
    if ($8f618495e45e290c$var$patternFormatGlobalState === undefined) $8f618495e45e290c$var$patternFormatGlobalState = patternFormat;
}
function $8f618495e45e290c$export$8bf1367cc4bb66da() {
    return $8f618495e45e290c$var$resolvedFlatPatternFileFormatGlobalState;
}
function $8f618495e45e290c$export$2bd306fd2b97e710(value) {
    if ($8f618495e45e290c$var$resolvedFlatPatternFileFormatGlobalState === undefined) $8f618495e45e290c$var$resolvedFlatPatternFileFormatGlobalState = value;
}
function $8f618495e45e290c$export$8835d45f445e6ba4() {
    return $8f618495e45e290c$var$hasInitialized;
}
function $8f618495e45e290c$export$9dfdd17bbd03b460() {
    return $8f618495e45e290c$var$productGlobalState;
}
function $8f618495e45e290c$export$d96c3b0fb6d35c5d() {
    return $8f618495e45e290c$var$webStorageControlsEnabledGlobalState;
}
function $8f618495e45e290c$export$c8554d68c78456d3() {
    return $8f618495e45e290c$var$indexedDbControlsEnabledGlobalState;
}
function $8f618495e45e290c$export$ea650e4f51ec84d8() {
    return $8f618495e45e290c$var$disableWebStorageConsentChecksGlobalState;
}
function $8f618495e45e290c$export$fa1f6ebb49ec4b30() {
    return $8f618495e45e290c$var$allowUncategorizedCookiesInOverridesGlobalState;
}
function $8f618495e45e290c$export$b60c6437117dfaf9() {
    return $8f618495e45e290c$var$allowUncategorizedItemsInWebStorageOverridesGlobalState;
}
function $8f618495e45e290c$export$cff869f7e58c9036() {
    return $8f618495e45e290c$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState;
}
function $8f618495e45e290c$export$491d0e6c401a0697(date) {
    if ($8f618495e45e290c$var$cacheLoadedDateGlobalState === undefined) $8f618495e45e290c$var$cacheLoadedDateGlobalState = date;
}
function $8f618495e45e290c$export$ea32fe1e8610fd3b() {
    return $8f618495e45e290c$var$disableIndexedDbConsentChecksGlobalState;
}

});
parcelRegister("hw3pG", function(module, exports) {
$parcel$export(module.exports, "PreferenceCategory", () => $572d77eca73f8fb6$export$ba064dbfe4bb66d7);
$parcel$export(module.exports, "ConsentPreferenceV2", () => $572d77eca73f8fb6$export$cdef20bac194f235);
$parcel$export(module.exports, "ContextualConsentProperty", () => $572d77eca73f8fb6$export$fac80ad19b60e313);
$parcel$export(module.exports, "PrefetchedPreferenceState", () => $572d77eca73f8fb6$export$5d6594a0bba4ab8a);
$parcel$export(module.exports, "CategoryStorageType", () => $572d77eca73f8fb6$export$2506b012eb637f61);
$parcel$export(module.exports, "Status", () => $572d77eca73f8fb6$export$96e9906d6d93a972);
var $572d77eca73f8fb6$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $572d77eca73f8fb6$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $572d77eca73f8fb6$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $572d77eca73f8fb6$export$4fda8eb914d6791c = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var $572d77eca73f8fb6$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var $572d77eca73f8fb6$export$2506b012eb637f61 = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    CategoryStorageType["IndexedDB"] = "IndexedDB";
    return CategoryStorageType;
}({});
var $572d77eca73f8fb6$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    Status["ERROR"] = "ERROR";
    return Status;
}({});
var $572d77eca73f8fb6$export$eefdbcf75990494a = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({});

});

parcelRegister("i3sVo", function(module, exports) {
$parcel$export(module.exports, "determineLogLevel", () => $6ed6265567caea36$export$5461380538f47d52);
$parcel$export(module.exports, "resetLogLevelCache", () => $6ed6265567caea36$export$977223726df102da);

var $k3O8N = parcelRequire("k3O8N");

var $llCao = parcelRequire("llCao");

var $4kM1J = parcelRequire("4kM1J");

var $85guo = parcelRequire("85guo");
/**
 * Returns the active log level for the BSC Logger, resolved from (in order):
 * developer cookie override, consumer init param, or `DEFAULT_LOG_LEVEL`.
 *
 * The first call resolves and caches; subsequent calls return the cached
 * value. `initializeGlobalState` invalidates the cache via
 * `resetLogLevelCache()` so an init that runs after the first Logger call
 * still picks up the consumer's `packageLogLevel`.
 *
 * SSR caveat: `cachedLogLevel` is a module-level singleton, so in a shared
 * Node module cache it persists across requests. Both `initializeGlobalState`
 * and `clearGlobalState` call `resetLogLevelCache()`, so per-request init and
 * teardown keep it correct — one request's resolved level cannot leak into the
 * next.
 */ let $6ed6265567caea36$var$cachedLogLevel;
const $6ed6265567caea36$export$5461380538f47d52 = ()=>{
    if ($6ed6265567caea36$var$cachedLogLevel !== undefined) return $6ed6265567caea36$var$cachedLogLevel;
    $6ed6265567caea36$var$cachedLogLevel = $6ed6265567caea36$var$readDebugCookieOverride() ?? $6ed6265567caea36$var$readInitParamLogLevel() ?? (0, $85guo.DEFAULT_LOG_LEVEL);
    return $6ed6265567caea36$var$cachedLogLevel;
};
const $6ed6265567caea36$export$977223726df102da = ()=>{
    $6ed6265567caea36$var$cachedLogLevel = undefined;
};
/**
 * Returns `LogLevel.DEBUG` when the dev override is active (cookie set AND
 * the safety-net FF is enabled), else `null`. The FF gate lets us remotely
 * disable the cookie path if it ever misbehaves.
 *
 * The cookie is checked BEFORE the feature gate on purpose: `fg` is only ever
 * evaluated when the (rare, dev-only) `atl-bsc-debug-mode` cookie is present.
 * This keeps `Logger.*` calls — including ones that run at module-load time
 * (e.g. the AtlIndexedDb singleton) — from calling `fg` during a plain import.
 * Otherwise importing BSC crashes any consumer whose test mocks `fg` with a
 * not-yet-initialized factory variable ("Cannot access 'mockFg' before
 * initialization").
 */ const $6ed6265567caea36$var$readDebugCookieOverride = ()=>{
    let debugCookieSet = false;
    try {
        debugCookieSet = (0, $k3O8N.default).get('atl-bsc-debug-mode') === 'true';
    } catch  {
        // Cookie access can throw in sandboxed iframes / strict cookie policies.
        return null;
    }
    if (!debugCookieSet) return null;
    return (0, $llCao.fg)('platform_moonjelly_bsc_debug_mode') ? (0, $85guo.LogLevel).DEBUG : null;
};
/**
 * Returns the LogLevel corresponding to the consumer's `packageLogLevel` init
 * param, or `null` if unset or unrecognized.
 */ const $6ed6265567caea36$var$readInitParamLogLevel = ()=>{
    return (0, $85guo.packageLogLevelStringToEnum)((0, $4kM1J.getBscGlobalState)().packageLogLevel);
};

});
parcelRegister("85guo", function(module, exports) {
$parcel$export(module.exports, "LogLevel", () => $1003abcd6816137e$export$243e62d78d3b544d);
$parcel$export(module.exports, "DEFAULT_LOG_LEVEL", () => $1003abcd6816137e$export$97d4c6871900dcac);
$parcel$export(module.exports, "packageLogLevelStringToEnum", () => $1003abcd6816137e$export$6b31b02af0747fdf);
/**
 * Internal numeric log level. Higher = more verbose; a Logger method fires
 * when the resolved level is `>=` its own. Not exported from the package's
 * public entry — consumers use `PackageLogLevel` instead.
 */ var $1003abcd6816137e$export$243e62d78d3b544d = /*#__PURE__*/ function(LogLevel) {
    LogLevel[LogLevel["SILENT"] = 0] = "SILENT";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["INFO"] = 3] = "INFO";
    LogLevel[LogLevel["DEBUG"] = 4] = "DEBUG";
    return LogLevel;
}({});
const $1003abcd6816137e$export$97d4c6871900dcac = 1;
const $1003abcd6816137e$var$PACKAGE_LOG_LEVEL_BY_STRING = {
    silent: 0,
    error: 1,
    warn: 2,
    info: 3,
    debug: 4
};
const $1003abcd6816137e$export$6b31b02af0747fdf = (value)=>{
    if (value === undefined) return null;
    return $1003abcd6816137e$var$PACKAGE_LOG_LEVEL_BY_STRING[value] ?? null;
};

});



const $9f5054f87e3e2d3a$export$5e28bf885ebebfa6 = '[browser-storage-controls]';
const $9f5054f87e3e2d3a$export$aeb1f5aa1188ce28 = 5000; // min gap between sends of the same action
const $9f5054f87e3e2d3a$export$ee3d07c2528881e2 = 10; // hard cap per action per page load

parcelRegister("6PIqM", function(module, exports) {
$parcel$export(module.exports, "packageName", () => $4c50ab34ef1c7931$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $4c50ab34ef1c7931$export$91546b032799aa40);
const $4c50ab34ef1c7931$export$9345d7360ffe0722 = "platform-pkg" ?? '';
const $4c50ab34ef1c7931$export$91546b032799aa40 = "0.0.0-use.local" ?? '';

});

parcelRegister("2FGbl", function(module, exports) {
$parcel$export(module.exports, "packageName", () => $da156047f654064f$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $da156047f654064f$export$91546b032799aa40);
// eslint-disable-next-line import/no-extraneous-dependencies

var $3PfHG = parcelRequire("3PfHG");
const $da156047f654064f$export$9345d7360ffe0722 = (0, (/*@__PURE__*/$parcel$interopDefault($3PfHG))).name;
const $da156047f654064f$export$91546b032799aa40 = (0, (/*@__PURE__*/$parcel$interopDefault($3PfHG))).version;

});
parcelRegister("3PfHG", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@atlassian/browser-storage-controls\",\"version\":\"11.3.0\",\"description\":\"Package containing utilities and components for collecting and enforcing user preferences on atlassian browser storage (cookies,localstorage, indexedDB etc.)\",\"publishConfig\":{\"registry\":\"https://packages.atlassian.com/api/npm/npm-remote\"},\"repository\":\"https://bitbucket.org/atlassian/atlassian-frontend-monorepo\",\"author\":\"Atlassian Pty Ltd\",\"main\":\"dist/cjs/index.js\",\"module\":\"dist/esm/index.js\",\"module:es2019\":\"dist/es2019/index.js\",\"types\":\"dist/types/index.d.ts\",\"sideEffects\":[\"*.compiled.css\"],\"atlaskit:src\":\"src/index.ts\",\"atlassian\":{\"team\":\"trust-privacy-controls-eng-team\",\"i18n\":true},\"scripts\":{\"webpack-build\":\"NODE_OPTIONS=--max-old-space-size=4096 webpack --env NODE_ENV=production --env prod --progress --config config/webpack.prod.js\",\"ak-postbuild\":\"NODE_OPTIONS=--max-old-space-size=4096 webpack --env NODE_ENV=production --env prod --progress --config config/webpack.prod.js && cp package.json dist/package.json\",\"test\":\"node -r esbuild-register build/ci/test-pipeline/scripts/run-test.ts -c packages/policy-platform/browser-storage-controls/jest.config.js\"},\"dependencies\":{\"@atlaskit/atlassian-context\":\"workspace:^\",\"@atlaskit/button\":\"workspace:^\",\"@atlaskit/checkbox\":\"workspace:^\",\"@atlaskit/feature-gate-js-client\":\"workspace:^\",\"@atlaskit/flag\":\"workspace:^\",\"@atlaskit/form\":\"workspace:^\",\"@atlaskit/heading\":\"workspace:^\",\"@atlaskit/icon\":\"workspace:^\",\"@atlaskit/intl-messages-provider\":\"workspace:^\",\"@atlaskit/modal-dialog\":\"workspace:^\",\"@atlaskit/platform-feature-flags\":\"workspace:^\",\"@atlaskit/primitives\":\"workspace:^\",\"@atlaskit/react-ufo\":\"workspace:^\",\"@atlaskit/tokens\":\"workspace:^\",\"@atlaskit/tooltip\":\"workspace:^\",\"@atlassian/afm-i18n-platform-policy-platform-browser-storage-controls\":\"root:*\",\"@atlassian/atl-context\":\"workspace:^\",\"@atlassian/ufo\":\"workspace:^\",\"@atlassian/ufo-experimental\":\"workspace:^\",\"@atlassiansox/analytics-web-client\":\"workspace:^\",\"@atlassiansox/frontend-feature-encoding\":\"root:*\",\"@babel/runtime\":\"root:*\",\"bind-event-listener\":\"root:*\",\"js-cookie\":\"root:*\",\"react-error-boundary\":\"root:*\",\"react-magnetic-di\":\"root:*\"},\"peerDependencies\":{\"react\":\"^18.2.0\",\"react-dom\":\"^18.2.0\",\"react-intl\":\"^5.25.1 || ^6.0.0 || ^7.0.0\"},\"devDependencies\":{\"@af/integration-testing\":\"workspace:^\",\"@af/visual-regression\":\"workspace:^\",\"@atlaskit/code\":\"workspace:^\",\"@atlaskit/css\":\"workspace:^\",\"@atlaskit/docs\":\"workspace:^\",\"@atlaskit/ssr\":\"workspace:^\",\"@atlaskit/toggle\":\"workspace:^\",\"@atlassian/feature-flags-storybook-utils\":\"workspace:^\",\"@atlassian/feature-flags-test-utils\":\"workspace:^\",\"@atlassian/multi-entry-tools\":\"workspace:^\",\"@atlassian/platform-storybook-helpers\":\"workspace:^\",\"@atlassian/testing-library\":\"workspace:^\",\"@babel/preset-typescript\":\"root:*\",\"@storybook/addon-actions\":\"root:*\",\"@storybook/test\":\"root:*\",\"@testing-library/react\":\"root:*\",\"@testing-library/user-event\":\"root:*\",\"@types/node\":\"root:*\",\"fake-indexeddb\":\"root:*\",\"fetch-mock\":\"root:*\",\"react\":\"root:*\",\"react-dom\":\"root:*\",\"react-intl\":\"root:*\",\"wait-for-expect\":\"root:*\",\"webpack-cli\":\"root:*\"},\"exports\":{\".\":\"./src/index.ts\",\"./banner-controls\":\"./src/controllers/banner-controls/index.ts\",\"./consent-banner\":\"./src/ui/consent-banner/index.tsx\",\"./consent-banner/preference-modal\":\"./src/ui/consent-banner/preference-modal/index.tsx\",\"./constants\":\"./src/constants.ts\",\"./controllers/banner-controls/get-banner-visibility\":\"./src/controllers/banner-controls/get-banner-visibility/index.ts\",\"./controllers/banner-controls/should-banner-render-prefetched\":\"./src/controllers/banner-controls/should-banner-render-prefetched/index.ts\",\"./controllers/banner-controls/should-banner-render\":\"./src/controllers/banner-controls/should-banner-render/index.ts\",\"./controllers/banner-controls/types\":\"./src/controllers/banner-controls/types.ts\",\"./controllers/cookie-controls/delete-cookie\":\"./src/controllers/cookie-controls/delete-cookie/index.ts\",\"./controllers/cookie-controls/get-cookie\":\"./src/controllers/cookie-controls/get-cookie/index.ts\",\"./controllers/cookie-controls/initialize-controls\":\"./src/controllers/cookie-controls/initialize-controls/index.ts\",\"./controllers/cookie-controls/set-cookie\":\"./src/controllers/cookie-controls/set-cookie/index.ts\",\"./controllers/cookie-controls/set-cookie/types\":\"./src/controllers/cookie-controls/set-cookie/types.ts\",\"./controllers/cookie-controls/set-strictly-necessary-cookie\":\"./src/controllers/cookie-controls/set-strictly-necessary-cookie/index.ts\",\"./controllers/cookie-controls/transformer\":\"./src/controllers/cookie-controls/transformer/index.ts\",\"./controllers/preferences-controls/get-preferences\":\"./src/controllers/preferences-controls/get-preferences/index.ts\",\"./controllers/third-party-controls/check-third-party\":\"./src/controllers/third-party-controls/check-third-party/index.ts\",\"./cookie-controls\":\"./src/controllers/cookie-controls/index.ts\",\"./core\":\"./src/common/utils/bsc-global-state/core.ts\",\"./consent-hub-service/types\":\"./src/services/consent-hub-service/types.ts\",\"./consent-hub-service/utils\":\"./src/services/consent-hub-service/utils.ts\",\"./i18n/*\":{\"publish\":null,\"default\":\"./src/i18n/*.ts\"},\"./indexed-db-wrapper-service\":\"./src/services/indexed-db-wrapper-service/index.ts\",\"./indexed-db-wrapper-service/types\":\"./src/services/indexed-db-wrapper-service/types.ts\",\"./types\":\"./src/types.ts\",\"./utils/item-processing\":\"./src/common/utils/item-processing/index.ts\",\"./utils/load-storage-controls-data/constants\":\"./src/common/utils/load-storage-controls-data/constants.ts\",\"./web-storage-service\":\"./src/services/web-storage-service/index.ts\",\"./web-storage-service/types\":\"./src/services/web-storage-service/types.ts\"},\"platform-feature-flags\":{\"platform_bsc_auto_detect_perimeter\":{\"type\":\"boolean\"},\"platform.moonjelly.block-unknown-cookies\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_ssr_killswitch\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_ui_killswitch\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_master_killswitch\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_debug_mode\":{\"type\":\"boolean\"},\"platform_moonjelly_bsc_web_storage_killswitch\":{\"type\":\"boolean\"},\"product-terminology-refresh\":{\"type\":\"boolean\"},\"platform_remove_bsc_overrides\":{\"type\":\"boolean\"},\"platform_bsc_flat_pattern_file_structure\":{\"type\":\"boolean\"},\"platform_bsc_ssr_flat_pattern_file_format\":{\"type\":\"boolean\"},\"platform_bsc_longest_pattern_match_wins\":{\"type\":\"boolean\"},\"platform_bsc_flat_lookup_skip_merge\":{\"type\":\"boolean\"},\"platform_bsc_cleanup_revoked_storage_live_delete\":{\"type\":\"boolean\"},\"platform_bsc_consent_hub_x_origin_app_normalized\":{\"type\":\"boolean\"},\"platform_bsc_browser_extension_detection\":{\"type\":\"boolean\"},\"platform_bsc_consent_bypass_analytics\":{\"type\":\"boolean\"},\"platform_bsc_sync_initialize_controls\":{\"type\":\"boolean\"},\"platform_bsc_use_generated_package_info\":{\"type\":\"boolean\"},\"platform_dst_modal-dialog-use-modal-title\":{\"type\":\"boolean\",\"referenceOnly\":true}}}");

});


parcelRegister("g5xfM", function(module, exports) {
$parcel$export(module.exports, "withAnalyticsEventSampling", () => $2093513398575f1c$export$67b6e87f323cb6ad);

var $hw3pG = parcelRequire("hw3pG");

var $4kM1J = parcelRequire("4kM1J");

var $3RPS0 = parcelRequire("3RPS0");

var $5W9qx = parcelRequire("5W9qx");
const $2093513398575f1c$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 1000,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    indexDbSetRecordError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1,
    usedAtlIndexedDBOpen: 100,
    usedAtlIndexedDBOpenError: 1,
    usedAtlIndexedDBOpenStrictlyNecessary: 100,
    usedAtlIndexedDBOpenStrictlyNecessaryError: 1,
    bscInitControlsParameters: 1000,
    setItemWithoutInit: 1000,
    uncategorizedWebStorageItemSet: 100,
    browserExtensionKeysAllowed: 100,
    storageCleanupCategorized: 100,
    storageCleanupDeleted: 100,
    storageCleanupError: 1,
    detectPerimeterError: 1,
    usedAtlBrowserStorageSetItemBscDisabled: 100,
    usedSetCookieMasterKillswitch: 100,
    cookieConsentPreferences: 1,
    cookieConsentModal: 1,
    cookieConsentBanner: 1,
    preferences: 1,
    onlyNecessary: 1,
    acceptAll: 1,
    cookiesTrackingNotice: 1,
    confirm: 1,
    performanceConsent: 1,
    functionalConsent: 1,
    targetingConsent: 1,
    cancel: 1,
    close: 1,
    background: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $2093513398575f1c$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $2093513398575f1c$var$loadSamplingConfig() {
    if ((0, $3RPS0.cache).cachedSamplingConfig) return (0, $3RPS0.cache).cachedSamplingConfig;
    if ((0, $5W9qx.isSSR)()) return undefined;
    const { loadCache: loadCache } = (0, $4kM1J.getBscGlobalState)();
    const controlsData = await loadCache((0, $hw3pG.CategoryStorageType).Cookies);
    const analyticsSamplingRatioConfigs = controlsData?.analyticsSamplingRatio;
    (0, $3RPS0.cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $2093513398575f1c$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($2093513398575f1c$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $2093513398575f1c$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $2093513398575f1c$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig ?? $2093513398575f1c$export$1138592b3c099377;
    const samplingRatio = samplingConfig?.[analyticsEventKey] !== undefined ? samplingConfig[analyticsEventKey] : $2093513398575f1c$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $2093513398575f1c$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
       ________
      /\       \
     /()\   ()  \
    /    \_______\
    \    /()     /
     \()/   ()  /
      \/_____()/
  */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $2093513398575f1c$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $2093513398575f1c$export$b286f5e8716d11ad(analyticsEventKey);
    $2093513398575f1c$export$dc2f0946255b3f89(ratio, cb);
}

});
parcelRegister("3RPS0", function(module, exports) {
$parcel$export(module.exports, "cache", () => $8e8e65c8af5d9459$export$69a3209f1a06c04d);

var $03MWL = parcelRequire("03MWL");
const $8e8e65c8af5d9459$export$69a3209f1a06c04d = new (0, $03MWL.CachedSamplingConfig)();

});
parcelRegister("03MWL", function(module, exports) {
$parcel$export(module.exports, "CachedSamplingConfig", () => $1f9ec56b737137ea$export$b886edaf6623554a);
class $1f9ec56b737137ea$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
}

});


parcelRegister("5W9qx", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $b12addcdc4af9bf6$export$48d7c418edadb60c);

var $50L3Y = parcelRequire("50L3Y");

var $llCao = parcelRequire("llCao");
const $b12addcdc4af9bf6$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $llCao.fg);
    const isMissingAnalyticsWebClient = !Boolean((0, $50L3Y.default));
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};

});



parcelRegister("2yNBb", function(module, exports) {
$parcel$export(module.exports, "Logger", () => $ae8fda249099385d$export$efa9a398d6368992);
/* eslint-disable no-console */ 
var $52k2b = parcelRequire("52k2b");


var $i3sVo = parcelRequire("i3sVo");

var $epqvn = parcelRequire("epqvn");

var $85guo = parcelRequire("85guo");
const $ae8fda249099385d$var$formatMetadata = (metadata)=>{
    if (!metadata) return '';
    // `LoggingMetadata` allows a bare string; emit it as-is rather than running it
    // through JSON.stringify, which would wrap it in extra quotes ("error-code" -> '"error-code"').
    return typeof metadata === 'string' ? metadata : JSON.stringify(metadata);
};
class $ae8fda249099385d$export$efa9a398d6368992 {
    // Console output is controlled solely by the resolved log level. `DEFAULT_LOG_LEVEL` is ERROR,
    // so info/warn/debug stay silent unless a consumer raises `packageLogLevel` or a developer sets
    // the `atl-bsc-debug-mode` cookie. ERROR output is intentionally always on.
    //
    // Keep these guards free of `fg` calls: `Logger.*` runs at module-load time in some consumers
    // (e.g. the AtlIndexedDb singleton), and evaluating a feature gate during a plain import breaks
    // consumers whose tests mock `fg` with a not-yet-initialized factory variable. The one gate this
    // path can still reach is handled in determine-log-level.ts, which checks its cookie first.
    static info(message, metadata) {
        if ((0, $i3sVo.determineLogLevel)() >= (0, $85guo.LogLevel).INFO) console.info(`${(0, $9f5054f87e3e2d3a$export$5e28bf885ebebfa6)}: ${message}`, $ae8fda249099385d$var$formatMetadata(metadata));
    }
    static warn(message, metadata) {
        if ((0, $i3sVo.determineLogLevel)() >= (0, $85guo.LogLevel).WARN) console.warn(`${(0, $9f5054f87e3e2d3a$export$5e28bf885ebebfa6)}: ${message}`, $ae8fda249099385d$var$formatMetadata(metadata));
    }
    static error(message, metadata) {
        if ((0, $i3sVo.determineLogLevel)() >= (0, $85guo.LogLevel).ERROR) console.error(`${(0, $9f5054f87e3e2d3a$export$5e28bf885ebebfa6)}: ${message}`, $ae8fda249099385d$var$formatMetadata(metadata));
    }
    static debug(message, metadata) {
        if ((0, $i3sVo.determineLogLevel)() >= (0, $85guo.LogLevel).DEBUG) console.debug(`${(0, $9f5054f87e3e2d3a$export$5e28bf885ebebfa6)}: DEBUG ${message}`, $ae8fda249099385d$var$formatMetadata(metadata));
    }
    /**
	 * Sends an unsampled operational event to backend telemetry and also emits the message via
	 * `Logger.error`. The telemetry send is throttled per-action (see error-event-throttle). The
	 * console output is always at ERROR level (subject to the resolved log level).
	 */ static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            // shouldSendErrorEvent records the send and limits per-action volume, so a repeatedly
            // failing call site cannot flood telemetry with duplicate events.
            if ((0, $epqvn.shouldSendErrorEvent)(action)) (0, $52k2b.sendUnsampledPackageOperationalEvent)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata);
    }
}

});
parcelRegister("epqvn", function(module, exports) {
$parcel$export(module.exports, "shouldSendErrorEvent", () => $3b7bb63327092033$export$e54335114720f029);

// Per-process (per page load) throttle state, keyed by operational event action.
// Resets naturally on page reload because module state is re-initialised, which gives
// us the "per session" semantic for free (same pattern as bsc-global-state).
const $3b7bb63327092033$var$throttleState = new Map();
function $3b7bb63327092033$export$e54335114720f029(action) {
    const now = Date.now();
    const entry = $3b7bb63327092033$var$throttleState.get(action);
    if (!entry) {
        // First occurrence of this action this session always sends.
        $3b7bb63327092033$var$throttleState.set(action, {
            lastSentAt: now,
            sentCount: 1
        });
        return true;
    }
    if (entry.sentCount >= (0, $9f5054f87e3e2d3a$export$ee3d07c2528881e2)) // Hard per-session cap reached — drop regardless of elapsed time.
    return false;
    if (now - entry.lastSentAt < (0, $9f5054f87e3e2d3a$export$aeb1f5aa1188ce28)) // Within the cooldown window since the last send for this action.
    return false;
    entry.lastSentAt = now;
    entry.sentCount += 1;
    return true;
}
function $3b7bb63327092033$export$a5ff37ede5ff9625() {
    $3b7bb63327092033$var$throttleState.clear();
}

});



parcelRegister("1vAhy", function(module, exports) {
$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $cb747670e46a004b$export$93509ff9a62ee022);

var $k3O8N = parcelRequire("k3O8N");

var $llCao = parcelRequire("llCao");

var $4kM1J = parcelRequire("4kM1J");
var $52k2b = parcelRequire("52k2b");

var $2yNBb = parcelRequire("2yNBb");
const $cb747670e46a004b$export$93509ff9a62ee022 = (key, value, attributes)=>{
    if ((0, $llCao.fg)('platform_moonjelly_bsc_master_killswitch')) // Set the cookie without package operational events
    // when master killswitch is enabled
    (0, $k3O8N.default).set(key, value, {
        ...attributes,
        'atl-set-cookie': true
    });
    else try {
        if (!(0, $4kM1J.getBscGlobalState)().hasInitialized) (0, $52k2b.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: 'Cookie'
            }
        });
        (0, $52k2b.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, $k3O8N.default).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $2yNBb.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
        throw e;
    }
};

});

parcelRegister("cJ9lp", function(module, exports) {
$parcel$export(module.exports, "getCookie", () => $0cc54dcb13bbc0fb$export$4be65e66cfa2648a);

var $k3O8N = parcelRequire("k3O8N");

var $llCao = parcelRequire("llCao");

var $52k2b = parcelRequire("52k2b");

var $2yNBb = parcelRequire("2yNBb");
function $0cc54dcb13bbc0fb$export$4be65e66cfa2648a(key) {
    if ((0, $llCao.fg)('platform_moonjelly_bsc_master_killswitch')) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, $k3O8N.default).get(key) : (0, $k3O8N.default).get();
    try {
        (0, $52k2b.sendPackageOperationalEvent)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, $k3O8N.default).get(key) : (0, $k3O8N.default).get();
    } catch (e) {
        (0, $2yNBb.Logger).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}

});

parcelRegister("9u6cV", function(module, exports) {
$parcel$export(module.exports, "payloadPublisher", () => $5ccf0d31157c17af$export$edb879ae55bb9be3);

var $llCao = parcelRequire("llCao");

var $8nBFK = parcelRequire("8nBFK");

var $8Vyrj = parcelRequire("8Vyrj");

var $kEf11 = parcelRequire("kEf11");

var $d55U0 = parcelRequire("d55U0");

var $bJHRc = parcelRequire("bJHRc");

var $4xOWz = parcelRequire("4xOWz");

var $8TSjH = parcelRequire("8TSjH");


var $8KSee = parcelRequire("8KSee");

var $1qSV4 = parcelRequire("1qSV4");

var $d5l8V = parcelRequire("d5l8V");

var $iEcJp = parcelRequire("iEcJp");

var $1LvoX = parcelRequire("1LvoX");

var $7AyIx = parcelRequire("7AyIx");

var $hUy3C = parcelRequire("hUy3C");

var $2ebdY = parcelRequire("2ebdY");

var $ivEmQ = parcelRequire("ivEmQ");

var $4N4Ot = parcelRequire("4N4Ot");

var $1Ybz6 = parcelRequire("1Ybz6");

var $hb8Yt = parcelRequire("hb8Yt");

var $7m7bK = parcelRequire("7m7bK");

var $6KzO1 = parcelRequire("6KzO1");

var $dr1QV = parcelRequire("dr1QV");

var $4GzGn = parcelRequire("4GzGn");

var $aGEoB = parcelRequire("aGEoB");

var $gonAW = parcelRequire("gonAW");
const $5ccf0d31157c17af$var$UNKNOWN_VALUE = 'unknown';
const $5ccf0d31157c17af$var$DEFAULT_PAYLOAD_DATA = {
    schemaVersion: $5ccf0d31157c17af$var$UNKNOWN_VALUE,
    id: $5ccf0d31157c17af$var$UNKNOWN_VALUE,
    uuid: $5ccf0d31157c17af$var$UNKNOWN_VALUE,
    state: {
        id: $5ccf0d31157c17af$var$UNKNOWN_VALUE
    },
    result: {
        startTime: 0,
        duration: 0,
        success: false
    },
    type: (0, $8nBFK.ExperienceTypes).Experience,
    category: $5ccf0d31157c17af$var$UNKNOWN_VALUE,
    performanceType: (0, $8nBFK.ExperiencePerformanceTypes).Custom,
    metadata: {},
    explicitTimings: {},
    metrics: {
        startTime: 0,
        endTime: 0,
        marks: []
    },
    platform: null,
    children: [],
    pageVisibleState: (0, $4xOWz.PageVisibleState).MIXED,
    isSSROutputAsFMP: false,
    timings: [],
    featureFlags: []
};
class $5ccf0d31157c17af$var$Publisher {
    publish(data) {
        const payloadStart = (0, $4GzGn.getPerformanceObject)()?.now() || 0;
        const experienceKey = this.getExperienceKey(data);
        if (!this.allowlist(experienceKey, data)) {
            (0, $bJHRc.ufowarn)(`experience ${experienceKey} does not meet requirements of allowlist`);
            return;
        }
        // it is used to setup default properties on the data to prevent errors
        const supportedData = {
            ...$5ccf0d31157c17af$var$DEFAULT_PAYLOAD_DATA,
            ...data
        };
        const payload = {
            actionSubject: 'experience',
            action: 'measured',
            source: 'measured',
            tags: [
                'observability'
            ],
            attributes: {
                properties: {
                    'event:source': {
                        name: 'ufo/web',
                        version: supportedData.schemaVersion
                    },
                    'event:schema': (0, $15a246887205f3f6$export$93809551debf385f) || $5ccf0d31157c17af$var$UNKNOWN_VALUE,
                    'event:product': this.product,
                    'event:region': this.region,
                    ...(0, $llCao.fg)('ufo_cdp_attribute') ? {
                        'event:cdp': this.cdp
                    } : null,
                    'event:hostname': this.hostname,
                    'event:route': this.route.getRoute(),
                    ...(0, $2ebdY.eventBrowserPlugin)(),
                    ...(0, $ivEmQ.eventCpusPlugin)(),
                    ...(0, $1Ybz6.eventMemoryPlugin)(),
                    ...(0, $hb8Yt.eventNetworkPlugin)(),
                    ...(0, $7AyIx.appFramework)(this.app),
                    ...(0, $hUy3C.appVersion)(this.app),
                    'experience:name': supportedData.id,
                    // platform.fe.page-load|interaction|custom|page-segment.editor
                    'experience:key': experienceKey,
                    'experience:status': supportedData.state.id,
                    'experience:duration': supportedData.result.duration,
                    ...supportedData.result.startTime !== null ? {
                        'experience:startTime': supportedData.result.startTime
                    } : null,
                    ...supportedData.uuid ? {
                        'experience:spanId': supportedData.uuid
                    } : null,
                    ...this.tenantType !== (0, $8KSee.TenantType).RealUser ? {
                        'event:tenantType': this.tenantType
                    } : null,
                    ...this.mapMetadataToPayload(supportedData.metadata),
                    ...this.extractPageLoadData(supportedData),
                    ...(0, $iEcJp.pageVisibleState)(supportedData),
                    ...(0, $gonAW.isInitialPageLoad)(supportedData) && (0, $6KzO1.ssrSuccess)(this.ssr),
                    ...(0, $gonAW.isInitialPageLoad)(supportedData) && (0, $7m7bK.ssrFeatureFlags)(this.ssr),
                    ...this.featureFlagClient && (0, $4N4Ot.featureFlags)(this.featureFlagClient, this.featureFlags, supportedData)
                },
                performance: {
                    ...this.getPerformanceMetrics(supportedData),
                    ...supportedData.traceContext ? {
                        'ufo:tracingContext': {
                            'X-B3-TraceId': supportedData.traceContext.traceId,
                            'X-B3-SpanId': supportedData.traceContext.spanId,
                            browserTimeOrigin: (0, $4GzGn.getPerformanceObject)()?.timeOrigin ?? 0
                        }
                    } : null
                },
                task: supportedData.id
            }
        };
        const payloadEnd = (0, $4GzGn.getPerformanceObject)()?.now() || 0;
        payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
        if (this.gasv3) this.gasv3.sendOperationalEvent(payload);
        else this.buffer.push(payload);
        (0, $d55U0.ufolog)('PAYLOAD:', JSON.stringify(payload, null, 2));
    }
    setGlobalEventStream() {
        if (!((0, $8Vyrj.getGlobalEventStream)() instanceof (0, $1qSV4.UFOGlobalEventStream))) {
            const eventStream = new (0, $1qSV4.UFOGlobalEventStream)();
            eventStream.push({
                type: (0, $4xOWz.UFOGlobalEventStreamEventType).SUBSCRIBE,
                payload: {
                    experienceId: '__SUBSCRIBE_ALL__',
                    callback: this.publish.bind(this)
                }
            });
            (0, $kEf11.setGlobalEventStream)(eventStream);
        }
    }
    setRoute(newRoute) {
        this.route.setRoute(newRoute);
    }
    setup(config) {
        (0, $8TSjH.visibilityChangeObserver).start();
        (0, $1LvoX.resourceTimingBuffer).start();
        if (!this.product) this.product = config.product || '';
        if (config.allowlist) this.allowlist = config.allowlist;
        if (config.tenantType) this.tenantType = config.tenantType;
        if (config.hostname) this.hostname = config.hostname;
        if (config.region) this.region = config.region;
        if (config.cdp) this.cdp = config.cdp;
        if (config.app) this.app = config.app;
        if (config.featureFlagClient) this.featureFlagClient = config.featureFlagClient;
        if (config.featureFlags) this.featureFlags = config.featureFlags;
        if (config.ssr) this.ssr = config.ssr;
        if (config.bundleEvalTimings) this.bundleEvalTimings = config.bundleEvalTimings;
        if (config.resourceTimings) this.resourceTimings = config.resourceTimings;
        if (config.performanceConfig) this.performanceConfig = config.performanceConfig;
        if (config.plugins) this.plugins = config.plugins;
        this.setGlobalEventStream();
        if (!this.gasv3) {
            this.gasv3 = config.gasv3;
            this.buffer.forEach(this.gasv3.sendOperationalEvent);
        }
    }
    mapMetadataToPayload(metadata) {
        const payload = {};
        Object.entries(metadata).forEach(([key, value])=>{
            if (value !== undefined) payload[`custom:${key}`] = value;
        });
        return payload;
    }
    extractPageLoadData(data) {
        if ('initial' in data) return {
            'experience:pageLoadType': data.initial ? 'initial' : 'transition'
        };
        return {};
    }
    getPrefix(data) {
        if (data.platform !== null) return 'platform';
        return this.product;
    }
    getExperienceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.type
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.performanceType
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceType(data) {
        return data.performanceType;
    }
    getPerformanceMetrics(data) {
        return {
            'event:key': this.getExperiencePerformanceKey(data),
            'event:type': this.getExperiencePerformanceType(data),
            ...(0, $d5l8V.getPerformancePayload)(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig),
            ...this.getPluginsMetrics(data)
        };
    }
    constructor(){
        this.gasv3 = null;
        this.product = '';
        this.region = $5ccf0d31157c17af$var$UNKNOWN_VALUE;
        this.cdp = $5ccf0d31157c17af$var$UNKNOWN_VALUE;
        this.hostname = (0, $aGEoB.getWindowObject)()?.location?.hostname || '';
        this.tenantType = (0, $8KSee.TenantType).RealUser;
        this.app = {
            version: {
                web: $5ccf0d31157c17af$var$UNKNOWN_VALUE
            }
        };
        this.performanceConfig = {};
        this.buffer = [];
        this.featureFlagClient = null;
        this.featureFlags = [];
        this.ssr = null;
        this.resourceTimings = null;
        this.bundleEvalTimings = null;
        this.route = (0, $dr1QV.Route);
        this.plugins = null;
        this.allowlist = ()=>true;
        this.getPluginsMetrics = (data)=>{
            const result = {};
            if (this.plugins) this.plugins.forEach((plugin)=>{
                const pluginOutput = plugin({
                    ...data
                });
                if (pluginOutput === null || typeof pluginOutput !== 'object') return;
                Object.entries(pluginOutput).forEach(([key, value])=>{
                    result[`${this.product}:${key}`] = value;
                });
            });
            return result;
        };
    }
}
const $5ccf0d31157c17af$export$edb879ae55bb9be3 = new $5ccf0d31157c17af$var$Publisher();

});
parcelRegister("kEf11", function(module, exports) {
$parcel$export(module.exports, "setGlobalEventStream", () => $55a24de4116fb82b$export$c1522520b417b066);

var $bJHRc = parcelRequire("bJHRc");
const $55a24de4116fb82b$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $bJHRc.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};

});

// temp solution until a proper versioning
const $15a246887205f3f6$export$93809551debf385f = '0.1.7';

parcelRegister("8KSee", function(module, exports) {
$parcel$export(module.exports, "TenantType", () => $447a5c97da019069$export$92a757ac1398962f);
var $447a5c97da019069$export$92a757ac1398962f = /*#__PURE__*/ function(TenantType) {
    TenantType["RealUser"] = "real-user";
    TenantType["Synthetic"] = "synthetic";
    return TenantType;
}({});

});

parcelRegister("1qSV4", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStream", () => $4c0af2714ff3e49a$export$faf4c91b80fc830e);

var $d55U0 = parcelRequire("d55U0");

var $4xOWz = parcelRequire("4xOWz");
class $4c0af2714ff3e49a$export$faf4c91b80fc830e {
    push(event) {
        (0, $d55U0.ufolog)('EVENT STREAM push', event.type, event.payload);
        if (event.type === (0, $4xOWz.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD) this.publish(event.payload);
        if (event.type === (0, $4xOWz.UFOGlobalEventStreamEventType).SUBSCRIBE) this.subscribe(event.payload.experienceId, event.payload.callback);
        if (event.type === (0, $4xOWz.UFOGlobalEventStreamEventType).UNSUBSCRIBE) this.unsubscribe(event.payload.experienceId, event.payload.callback);
    }
    publish(eventPayload) {
        if (this.subscribers[0, $4xOWz.SUBSCRIBE_ALL]) this.subscribers[0, $4xOWz.SUBSCRIBE_ALL].forEach((fn)=>{
            fn(eventPayload);
        });
        this.subscribers[eventPayload.id]?.forEach((fn)=>{
            fn(eventPayload);
        });
    }
    subscribe(experienceId, fn) {
        (0, $d55U0.ufolog)('EVENT STREAM subscribe', experienceId);
        if (!this.subscribers[experienceId]) this.subscribers[experienceId] = [];
        this.subscribers[experienceId].push(fn);
    }
    unsubscribe(experienceId, fn) {
        const index = this.subscribers[experienceId].findIndex((entry)=>entry === fn);
        if (index !== -1) this.subscribers[experienceId].splice(index, 1);
    }
    constructor(){
        this.__buffer_only__ = false;
        this.subscribers = {};
    }
}

});

parcelRegister("d5l8V", function(module, exports) {
$parcel$export(module.exports, "getPerformancePayload", () => $5b77d658d4474e3f$export$738d24377baf6a5e);

var $8nBFK = parcelRequire("8nBFK");

var $gonAW = parcelRequire("gonAW");

var $jrlfW = parcelRequire("jrlfW");

var $dRnm5 = parcelRequire("dRnm5");

var $1PScn = parcelRequire("1PScn");

var $76WUB = parcelRequire("76WUB");

var $aVkMb = parcelRequire("aVkMb");

var $bHzgt = parcelRequire("bHzgt");

var $brCgT = parcelRequire("brCgT");
const $5b77d658d4474e3f$var$getPerformanceMetrics = (data, ssr, performanceConfig)=>{
    switch(data.performanceType){
        case (0, $8nBFK.ExperiencePerformanceTypes).PageLoad:
        case (0, $8nBFK.ExperiencePerformanceTypes).PageSegmentLoad:
            return (0, $1PScn.getLoadMetrics)(data, ssr, performanceConfig);
        case (0, $8nBFK.ExperiencePerformanceTypes).InlineResult:
            return (0, $dRnm5.getInlineResultMetrics)(data, performanceConfig);
        case (0, $8nBFK.ExperiencePerformanceTypes).Custom:
            return (0, $jrlfW.getCustomMetrics)(data, performanceConfig);
    }
};
const $5b77d658d4474e3f$export$738d24377baf6a5e = (data, ssr, bundleEvalConfig, resourceConfig, performanceConfig)=>{
    return {
        ...$5b77d658d4474e3f$var$getPerformanceMetrics(data, ssr, performanceConfig),
        ...(0, $brCgT.resourceTimings)(data, resourceConfig),
        ...(0, $bHzgt.bundleEvalTimings)(data, bundleEvalConfig),
        ...(0, $aVkMb.appTimings)(data, ssr),
        ...(0, $gonAW.isInitialPageLoad)(data) ? (0, $76WUB.navigationMetrics)() : null
    };
};

});
parcelRegister("gonAW", function(module, exports) {
$parcel$export(module.exports, "isInitialPageLoad", () => $75b0140d69b37231$export$7167d96e9881d500);

var $8nBFK = parcelRequire("8nBFK");
const $75b0140d69b37231$export$7167d96e9881d500 = (data)=>{
    return data.performanceType === (0, $8nBFK.ExperiencePerformanceTypes).PageLoad && data.initial === true;
};

});

parcelRegister("jrlfW", function(module, exports) {
$parcel$export(module.exports, "getCustomMetrics", () => $173e8afc67256359$export$c25c1b3ff2ce92cf);

var $5mPKo = parcelRequire("5mPKo");

var $9jy94 = parcelRequire("9jy94");
const $173e8afc67256359$export$c25c1b3ff2ce92cf = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const duration = data.metrics.endTime - data.metrics.startTime;
    return {
        [(0, $5mPKo.CustomMetricKeys).duration]: Math.round(duration),
        ...(0, $9jy94.getHistogram)(data, performanceConfig)
    };
};

});
parcelRegister("5mPKo", function(module, exports) {
$parcel$export(module.exports, "CustomMetricKeys", () => $681b9ebf18ff1426$export$8b4d49d876b19889);
const $681b9ebf18ff1426$export$8b4d49d876b19889 = {
    duration: 'metric:duration',
    durationHistograms: 'metric:duration:histogramBuckets'
};

});

parcelRegister("9jy94", function(module, exports) {
$parcel$export(module.exports, "getHistogram", () => $200a1c3447e60aee$export$908946735178c541);

var $8nBFK = parcelRequire("8nBFK");

var $5mPKo = parcelRequire("5mPKo");

var $9pIVQ = parcelRequire("9pIVQ");

var $cBhZX = parcelRequire("cBhZX");
const $200a1c3447e60aee$export$908946735178c541 = (data, performanceConfig, isInitial)=>{
    let histogram = {};
    if (data.performanceConfig?.histogram) histogram = data.performanceConfig.histogram;
    else if (performanceConfig?.histogram) histogram = performanceConfig.histogram;
    if (histogram) {
        const histograms = histogram[data.performanceType];
        switch(data.performanceType){
            case (0, $8nBFK.ExperiencePerformanceTypes).PageLoad:
            case (0, $8nBFK.ExperiencePerformanceTypes).PageSegmentLoad:
                const histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
                return histograms ? {
                    [(0, $cBhZX.LoadMetricKeys).ttiHistograms]: histograms[histogramType].tti,
                    [(0, $cBhZX.LoadMetricKeys).fmpHistograms]: histograms[histogramType].fmp
                } : {};
            case (0, $8nBFK.ExperiencePerformanceTypes).InlineResult:
                return histograms ? {
                    [(0, $9pIVQ.InlineResultMetricKeys).resultHistograms]: histograms.result,
                    [(0, $9pIVQ.InlineResultMetricKeys).responseHistograms]: histograms.response
                } : {};
            case (0, $8nBFK.ExperiencePerformanceTypes).Custom:
                return histograms ? {
                    [(0, $5mPKo.CustomMetricKeys).durationHistograms]: histograms.duration
                } : {};
        }
    }
    return undefined;
};

});
parcelRegister("9pIVQ", function(module, exports) {
$parcel$export(module.exports, "InlineResultMetricKeys", () => $93890c83f8d3e93e$export$1bc754b4266cc540);
const $93890c83f8d3e93e$export$1bc754b4266cc540 = {
    result: 'metric:result',
    response: 'metric:response',
    resultHistograms: 'metric:result:histogramBuckets',
    responseHistograms: 'metric:response:histogramBuckets'
};

});

parcelRegister("cBhZX", function(module, exports) {
$parcel$export(module.exports, "LoadMetricKeys", () => $0cf8697548cf481c$export$6869ee9ee4309612);
const $0cf8697548cf481c$export$6869ee9ee4309612 = {
    tti: 'metric:tti',
    fmp: 'metric:fmp',
    ttiHistograms: 'metric:tti:histogramBuckets',
    fmpHistograms: 'metric:fmp:histogramBuckets'
};

});



parcelRegister("dRnm5", function(module, exports) {
$parcel$export(module.exports, "getInlineResultMetrics", () => $599b3999b8559fe4$export$47f0208fd62dffce);

var $4xOWz = parcelRequire("4xOWz");

var $9jy94 = parcelRequire("9jy94");

var $9pIVQ = parcelRequire("9pIVQ");
const $599b3999b8559fe4$export$47f0208fd62dffce = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const responseMark = data.metrics.marks.find((mark)=>mark.name === (0, $4xOWz.INLINE_RESPONSE_MARK));
    const result = data.metrics.endTime - data.metrics.startTime;
    const response = responseMark ? responseMark.time - data.metrics.startTime : result;
    return {
        [(0, $9pIVQ.InlineResultMetricKeys).result]: Math.round(result),
        [(0, $9pIVQ.InlineResultMetricKeys).response]: Math.round(response),
        ...(0, $9jy94.getHistogram)(data, performanceConfig)
    };
};

});

parcelRegister("1PScn", function(module, exports) {
$parcel$export(module.exports, "getLoadMetrics", () => $2dbab2ff7e0b4894$export$bd4e6d81a822ece6);

var $4xOWz = parcelRequire("4xOWz");

var $gonAW = parcelRequire("gonAW");

var $9jy94 = parcelRequire("9jy94");

var $cBhZX = parcelRequire("cBhZX");
const $2dbab2ff7e0b4894$export$bd4e6d81a822ece6 = (data, ssr, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === (0, $4xOWz.FMP_MARK))?.time || (0, $gonAW.isInitialPageLoad)(data) && ssr?.getDoneMark();
    const tti = data.metrics.endTime - data.metrics.startTime;
    const fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
    return {
        [(0, $cBhZX.LoadMetricKeys).tti]: Math.round(tti),
        [(0, $cBhZX.LoadMetricKeys).fmp]: Math.round(fmp),
        ...(0, $9jy94.getHistogram)(data, performanceConfig)
    };
};

});

parcelRegister("76WUB", function(module, exports) {
$parcel$export(module.exports, "navigationMetrics", () => $ed4343655a0babde$export$b88d990436be0f8a);
const $ed4343655a0babde$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("aVkMb", function(module, exports) {
$parcel$export(module.exports, "appTimings", () => $7b05cafb8a331368$export$e952f50a4f2d02da);

var $8nBFK = parcelRequire("8nBFK");

var $gonAW = parcelRequire("gonAW");

var $608wD = parcelRequire("608wD");

var $4k385 = parcelRequire("4k385");
const $7b05cafb8a331368$export$e952f50a4f2d02da = (data, ssrConfig)=>{
    const explicitTimings = data.performanceType === (0, $8nBFK.ExperiencePerformanceTypes).PageLoad && data.explicitTimings || null;
    const timings = (0, $608wD.customTimings)(data);
    const ssr = (0, $gonAW.isInitialPageLoad)(data) ? (0, $4k385.ssrTimings)(ssrConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp || Object.keys(timingsApp).length === 0) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("608wD", function(module, exports) {
$parcel$export(module.exports, "customTimings", () => $2250a47c28df3d6f$export$6126f85083a72c6e);
const $2250a47c28df3d6f$var$retrieveTimings = (data)=>{
    const configTimings = data.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        const startMark = data.metrics.marks.find((mark)=>mark.name === timing.startMark);
        if (timing.startMark && !startMark) return entries;
        const endMark = data.metrics.marks.find((mark)=>mark.name === timing.endMark);
        if (timing.endMark && !endMark) return entries;
        if (data.metrics.startTime === null || data.metrics.endTime === null) return null;
        const startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
        const duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
        entries[`${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $2250a47c28df3d6f$export$6126f85083a72c6e = (data)=>{
    if (!data.timings) return null;
    const timings = $2250a47c28df3d6f$var$retrieveTimings(data);
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});

parcelRegister("4k385", function(module, exports) {
$parcel$export(module.exports, "ssrTimings", () => $52a509b0ef883000$export$130f411261a599c5);

const $52a509b0ef883000$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $52a509b0ef883000$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $52a509b0ef883000$var$SSR_PREFIX = 'ssr';
const $52a509b0ef883000$var$mapKey = (key)=>{
    if (key === 'total') return $52a509b0ef883000$var$SSR_PREFIX;
    return `${$52a509b0ef883000$var$SSR_PREFIX}${0, $1d063e541d94c81b$export$b98e411ae80c806f}${key}`;
};
const $52a509b0ef883000$export$130f411261a599c5 = (ssr)=>{
    if (!ssr?.getTimings) return null;
    const timings = ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($52a509b0ef883000$var$filterEntry(entry[1])) acc[$52a509b0ef883000$var$mapKey(entry[0])] = $52a509b0ef883000$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});
const $1d063e541d94c81b$export$b98e411ae80c806f = '/';



parcelRegister("bHzgt", function(module, exports) {
$parcel$export(module.exports, "bundleEvalTimings", () => $b064487037efe419$export$1a2bb347935fc536);

var $4GzGn = parcelRequire("4GzGn");
const $b064487037efe419$export$1a2bb347935fc536 = (data, bundleEvalTimings, performance = (0, $4GzGn.getPerformanceObject)() || undefined)=>{
    if (!bundleEvalTimings) return null;
    const started = {};
    const timings = {};
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result || data.result.startTime === null) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= data.result.startTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.result.startTime),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (bundleEvalTimings?.additionalTimings && data.result.startTime !== null) {
        const result = bundleEvalTimings.additionalTimings(data.result.startTime);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};

});
parcelRegister("4GzGn", function(module, exports) {
$parcel$export(module.exports, "getPerformanceObject", () => $c112168c62fb94aa$export$8cd0c777b0eb66a0);

var $aGEoB = parcelRequire("aGEoB");
const $c112168c62fb94aa$export$8cd0c777b0eb66a0 = ()=>{
    const { performance: performance } = (0, $aGEoB.getWindowObject)() || {};
    return performance;
};

});
parcelRegister("aGEoB", function(module, exports) {
$parcel$export(module.exports, "getWindowObject", () => $677a6404bbbca379$export$9aa44f85591248d9);
const $677a6404bbbca379$export$9aa44f85591248d9 = ()=>{
    return typeof window !== 'undefined' && !!window ? window : undefined;
};

});



parcelRegister("brCgT", function(module, exports) {
$parcel$export(module.exports, "resourceTimings", () => $db5ee52336d7290f$export$81a7d52441a06b50);

var $4GzGn = parcelRequire("4GzGn");

var $aGEoB = parcelRequire("aGEoB");

var $1LvoX = parcelRequire("1LvoX");
const $db5ee52336d7290f$var$cacheableTypes = [
    'script',
    'link'
];
const $db5ee52336d7290f$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $db5ee52336d7290f$var$CACHE_NETWORK = 'network';
const $db5ee52336d7290f$var$CACHE_MEMORY = 'memory';
const $db5ee52336d7290f$var$CACHE_DISK = 'disk';
const $db5ee52336d7290f$var$calculateTransferType = (type, duration, size)=>{
    if (!$db5ee52336d7290f$var$cacheableTypes.includes(type)) return $db5ee52336d7290f$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $db5ee52336d7290f$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $db5ee52336d7290f$var$CACHE_DISK;
    if (size === undefined) return null;
    return $db5ee52336d7290f$var$CACHE_NETWORK;
};
const $db5ee52336d7290f$var$hasAccessToResourceSize = (url, type, entry, hasTimingHeaders)=>{
    return !$db5ee52336d7290f$var$cacheableTypes.includes(type) || url.includes('localhost') || !!(0, $aGEoB.getWindowObject)() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
const $db5ee52336d7290f$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $db5ee52336d7290f$var$evaluateAccessToResourceTimings = (_url, entry)=>{
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
const $db5ee52336d7290f$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $db5ee52336d7290f$var$getNetworkData = (item, eventStart, hasTimingHeaders = $db5ee52336d7290f$var$evaluateAccessToResourceTimings)=>{
    const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$db5ee52336d7290f$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($db5ee52336d7290f$var$cacheableTypes.includes(initiatorType)) {
        const transferType = $db5ee52336d7290f$var$calculateTransferType(initiatorType, duration, transferSize);
        if (!transferType) return {
            ttfb: ttfb,
            ...$db5ee52336d7290f$var$getSizeObject(transferSize)
        };
        if (transferType !== $db5ee52336d7290f$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$db5ee52336d7290f$var$getSizeObject(transferSize)
        };
    }
    return {
        ttfb: ttfb,
        ...$db5ee52336d7290f$var$getSizeObject(transferSize)
    };
};
const $db5ee52336d7290f$export$81a7d52441a06b50 = (data, resourceTimings, performance = (0, $4GzGn.getPerformanceObject)() || undefined)=>{
    if (data.result.startTime === null || !resourceTimings?.sanitiseEndpoints) return null;
    const resources = (0, $1LvoX.getResourceTimings)(data.result.startTime, performance);
    if (!resources?.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = resourceTimings;
    const reportedInitiatorTypes = $db5ee52336d7290f$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
        if (!name || data.result.startTime === null) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $db5ee52336d7290f$var$resourceTypes.includes(initiatorType) ? resourceTimings.sanitiseEndpoints(name) : resourceTimings.mapResources(name);
        if (!url || resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.result.startTime),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
            type: initiatorType,
            ...$db5ee52336d7290f$var$getNetworkData(item, data.result.startTime, resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});
parcelRegister("1LvoX", function(module, exports) {
$parcel$export(module.exports, "resourceTimingBuffer", () => $ff20e364eaf85ecd$export$bea963256235a63e);
$parcel$export(module.exports, "getResourceTimings", () => $ff20e364eaf85ecd$export$9eebb59359c2e9e5);
// @flow strict-local

var $iVORW = parcelRequire("iVORW");

var $4GzGn = parcelRequire("4GzGn");

var $2jlWZ = parcelRequire("2jlWZ");
const $ff20e364eaf85ecd$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: (entry)=>({
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration),
            fetchStart: Math.round(entry.fetchStart || 0),
            workerStart: Math.round(entry.workerStart || 0),
            responseStart: Math.round(entry.responseStart || 0)
        }),
    start: (performance = (0, $4GzGn.getPerformanceObject)(), PerformanceObserver1 = (0, $2jlWZ.getPerformanceObserverObject)())=>{
        if (!PerformanceObserver1 || !performance || typeof PerformanceObserver1 === 'undefined') return;
        if ($ff20e364eaf85ecd$export$bea963256235a63e.observer) {
            (0, $iVORW.ufologger).warn('Observer is already running');
            return;
        }
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $ff20e364eaf85ecd$export$bea963256235a63e.timings = resources.map((resource)=>$ff20e364eaf85ecd$export$bea963256235a63e.transformResource(resource));
        $ff20e364eaf85ecd$export$bea963256235a63e.observer = new PerformanceObserver1($ff20e364eaf85ecd$export$bea963256235a63e.addTimings);
        $ff20e364eaf85ecd$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: ()=>{
        if ($ff20e364eaf85ecd$export$bea963256235a63e.observer) {
            $ff20e364eaf85ecd$export$bea963256235a63e.observer.disconnect();
            $ff20e364eaf85ecd$export$bea963256235a63e.observer = null;
        }
        $ff20e364eaf85ecd$export$bea963256235a63e.timings = [];
    },
    addTimings: (list)=>{
        const entries = list.getEntries().map((entry)=>$ff20e364eaf85ecd$export$bea963256235a63e.transformResource(entry));
        const overflow = $ff20e364eaf85ecd$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $ff20e364eaf85ecd$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $ff20e364eaf85ecd$export$bea963256235a63e.maxSize;
            $ff20e364eaf85ecd$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $ff20e364eaf85ecd$export$bea963256235a63e.timings.push(...entries);
    }
};
const $ff20e364eaf85ecd$export$9eebb59359c2e9e5 = (startTime, performance = (0, $4GzGn.getPerformanceObject)())=>{
    if (!PerformanceObserver || !$ff20e364eaf85ecd$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>timing.startTime >= startTime);
        return null;
    }
    return $ff20e364eaf85ecd$export$bea963256235a63e.timings.filter((timing)=>timing.startTime >= startTime);
};

});
parcelRegister("2jlWZ", function(module, exports) {
$parcel$export(module.exports, "getPerformanceObserverObject", () => $b41a71b1d2cc27c3$export$74560fd4e61fd440);

var $aGEoB = parcelRequire("aGEoB");
const $b41a71b1d2cc27c3$export$74560fd4e61fd440 = ()=>{
    const { PerformanceObserver: PerformanceObserver } = (0, $aGEoB.getWindowObject)() || {};
    return PerformanceObserver;
};

});




parcelRegister("iEcJp", function(module, exports) {
$parcel$export(module.exports, "pageVisibleState", () => $3904729136358211$export$723b4c298aca63af);

var $4xOWz = parcelRequire("4xOWz");
const $3904729136358211$export$723b4c298aca63af = (data)=>{
    return {
        'experience:pageVisible': data.pageVisibleState ?? (document.hidden ? (0, $4xOWz.PageVisibleState).HIDDEN : (0, $4xOWz.PageVisibleState).VISIBLE)
    };
};

});

parcelRegister("7AyIx", function(module, exports) {
$parcel$export(module.exports, "appFramework", () => $affb65b2e08a7047$export$e34e4529b979f74c);
const $affb65b2e08a7047$export$e34e4529b979f74c = (config)=>{
    if (!config.framework) return null;
    return {
        'app:framework:name': config.framework.name,
        'app:framework:version': config.framework.version
    };
};

});

parcelRegister("hUy3C", function(module, exports) {
$parcel$export(module.exports, "appVersion", () => $5b89717d698530d4$export$82ae485178b37419);
const $5b89717d698530d4$export$82ae485178b37419 = (config)=>{
    const pluginData = {
        'app:web:version': config.version.web
    };
    if (config.version.ssr) pluginData['app:ssr:version'] = config.version.ssr;
    return pluginData;
};

});

parcelRegister("2ebdY", function(module, exports) {
$parcel$export(module.exports, "eventBrowserPlugin", () => $a21c06d96b99ecf9$export$f435c2789ca334a7);

var $93P8Y = parcelRequire("93P8Y");

var $kZVJU = parcelRequire("kZVJU");

var $aGEoB = parcelRequire("aGEoB");
const $a21c06d96b99ecf9$export$f435c2789ca334a7 = (0, $kZVJU.default)(()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($93P8Y))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($93P8Y))).getParser((0, $aGEoB.getWindowObject)()?.navigator?.userAgent || '');
    return {
        'event:browser:name': browser.getBrowserName(),
        'event:browser:version': browser.getBrowserVersion()
    };
});

});

parcelRegister("ivEmQ", function(module, exports) {
$parcel$export(module.exports, "eventCpusPlugin", () => $0d63c39e10ef6e0c$export$db7649b8854107ad);

var $kZVJU = parcelRequire("kZVJU");
const $0d63c39e10ef6e0c$export$db7649b8854107ad = (0, $kZVJU.default)(()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'event:cpus': navigator.hardwareConcurrency
    };
});

});

parcelRegister("4N4Ot", function(module, exports) {
$parcel$export(module.exports, "featureFlags", () => $1eb73a48811d811c$export$e62953d023125748);
const $1eb73a48811d811c$export$e62953d023125748 = (featureFlagClient, featureFlags, data)=>{
    const allFeatureFlags = [
        ...featureFlags,
        ...data.featureFlags || []
    ];
    if (allFeatureFlags.length === 0) return null;
    const initialMemo = [];
    allFeatureFlags.reduce((memo, featureFlagKey)=>{
        const ffVal = featureFlagClient.getValue(featureFlagKey);
        if (ffVal !== undefined && ffVal !== null) memo.push([
            featureFlagKey,
            ffVal
        ]);
        return memo;
    }, initialMemo);
    const mappedFeatureFlags = Object.fromEntries(initialMemo);
    return {
        featureFlags: mappedFeatureFlags
    };
};

});

parcelRegister("1Ybz6", function(module, exports) {
$parcel$export(module.exports, "eventMemoryPlugin", () => $85d06b25c947d8fd$export$81efaf8414879a1a);

var $kZVJU = parcelRequire("kZVJU");
const $85d06b25c947d8fd$export$81efaf8414879a1a = (0, $kZVJU.default)(()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'event:memory': navigator.deviceMemory
    };
});

});

parcelRegister("hb8Yt", function(module, exports) {
$parcel$export(module.exports, "eventNetworkPlugin", () => $8b32b5f555d19feb$export$ce1cf816dce1da56);
const $8b32b5f555d19feb$export$ce1cf816dce1da56 = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("7m7bK", function(module, exports) {
$parcel$export(module.exports, "ssrFeatureFlags", () => $b9b5bf0163399c5a$export$fdbea518c19dfa8);
const $b9b5bf0163399c5a$export$fdbea518c19dfa8 = (ssr)=>{
    if (!ssr?.getFeatureFlags) return null;
    try {
        const featureFlags = ssr.getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};

});

parcelRegister("6KzO1", function(module, exports) {
$parcel$export(module.exports, "ssrSuccess", () => $5f6c6cc3fb4e0f9f$export$a3dc8251cf55b2e0);
const $5f6c6cc3fb4e0f9f$export$a3dc8251cf55b2e0 = (ssr)=>{
    if (ssr?.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("dr1QV", function(module, exports) {
$parcel$export(module.exports, "Route", () => $551475b19d32010f$export$e7b0ac011bb776c6);
const $551475b19d32010f$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});


const $5b20f9eca5080b27$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $5b20f9eca5080b27$export$f005e2e9f707cb5f = 'commercial';
const $5b20f9eca5080b27$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $5b20f9eca5080b27$export$a739cd5aac835909 = 'stg';
const $5b20f9eca5080b27$export$42dd0cdd351a4a9 = 'prod';
const $5b20f9eca5080b27$export$404582bc18fe4d9e = 'dev';

const $8d44ad6280d93004$export$42f4885608027d0c = 'non_boolean';

/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';

/* eslint-disable jira/filename-case */ const $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $eb8cfa569eede1a9$export$e9c56aa3b027d98f = 'jira-customer-service';
const $eb8cfa569eede1a9$export$1346c9aa3cbb477d = 'jira-software';
const $eb8cfa569eede1a9$export$202f50ee62667e32 = 'jira-product-discovery';
const $eb8cfa569eede1a9$export$db515c8cec1e6f79 = 'jira-core';
const $eb8cfa569eede1a9$export$c811f21c9ad05dc2 = 'confluence';
const $eb8cfa569eede1a9$export$961148c98d198270 = 'opsgenie';
const $eb8cfa569eede1a9$export$a310f85340477585 = 'assets';
const $eb8cfa569eede1a9$export$d5e9b613bc4c47f = 'compass';

const $9924ccd0a7eb3f48$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $9924ccd0a7eb3f48$export$f005e2e9f707cb5f = 'commercial';
const $9924ccd0a7eb3f48$export$17b81a3d6c98013c = 'isolated-cloud';
const $9924ccd0a7eb3f48$export$a739cd5aac835909 = 'staging';
const $9924ccd0a7eb3f48$export$42dd0cdd351a4a9 = 'prod';
const $9924ccd0a7eb3f48$export$404582bc18fe4d9e = 'dev';
const $9924ccd0a7eb3f48$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $9924ccd0a7eb3f48$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $9924ccd0a7eb3f48$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $9924ccd0a7eb3f48$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $9924ccd0a7eb3f48$export$b61e047ddcc35726 = 'GCP';
const $9924ccd0a7eb3f48$export$1baf17f3e645a2b2 = 'AWS';

/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // this is autogenerated file, see scripts/version-update.js
const $2604faf4ecb0fc27$export$a4ad2735b021c132 = '1.9.1';

const $d06951238cc95036$export$cf090d5281b5ae06 = 10000;
const $d06951238cc95036$export$8575e30be0feb909 = 30000;

// same types defined in analytics-web-client but avoid creating dependency with that
const $ddd31af8f515fa50$export$a1562d08625f5d7e = 'ui';
const $ddd31af8f515fa50$export$947dac6c72b26f81 = 'track';
const $ddd31af8f515fa50$export$f1d537d508d2945a = 'screen';
const $ddd31af8f515fa50$export$12346a674644c156 = 'operational';
const $ddd31af8f515fa50$export$b055de0e665cb20c = 'unknown';

/* eslint-disable jira/filename-case */ const $07aa4ba62fd6dab4$export$56940a9488e85199 = 'jira.fe.spa-';
const $07aa4ba62fd6dab4$export$45c4b6bf7935c69a = `${$07aa4ba62fd6dab4$export$56940a9488e85199}start`;
const $07aa4ba62fd6dab4$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $07aa4ba62fd6dab4$export$ff834eccc35b9089 = 'appBundleReady';
const $07aa4ba62fd6dab4$export$86b05e34d462ead8 = 'prefetchApiReady';
const $07aa4ba62fd6dab4$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $07aa4ba62fd6dab4$export$3ae43cc1782d058f = 'jswRenderStart';
const $07aa4ba62fd6dab4$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $07aa4ba62fd6dab4$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $07aa4ba62fd6dab4$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $07aa4ba62fd6dab4$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $07aa4ba62fd6dab4$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $07aa4ba62fd6dab4$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $07aa4ba62fd6dab4$export$99c08ec92759c71c = 'tti-raf-mark';
const $07aa4ba62fd6dab4$export$48552baa9db8ce1d = 'tti-raf';

/* eslint-disable jira/filename-case */ const $382ab3343e49976c$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $3a071bccf8601cb8$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx


$parcel$global.rlb("etQHy")
//# sourceMappingURL=shared~commons~atlassian~ar.14c912d3.js.map
